
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aDgKf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("kjD5h")).default; });

var $kjD5h = parcelRequire("kjD5h");

});
parcelRegister("kjD5h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e86c567ab983d0ac$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $aiugz = parcelRequire("aiugz");

var $1UUq1 = parcelRequire("1UUq1");
parcelRequire("dMM9X");
var $kyoYi = parcelRequire("kyoYi");

var $3FBn4 = parcelRequire("3FBn4");
const $e86c567ab983d0ac$export$386f3ec84bf404ad = (props)=>{
    var _props_ctaUrl;
    const localizedHref = (0, $3FBn4.useLocalizedHref)((_props_ctaUrl = props.ctaUrl) !== null && _props_ctaUrl !== void 0 ? _props_ctaUrl : "");
    const button = ()=>{
        if (props.ctaText && props.ctaText !== "" && props.ctaUrl && props.ctaUrl !== "") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Button), {
            href: localizedHref,
            children: props.ctaText
        });
        return;
    };
    var _button;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $kyoYi.CallToAction), {
        header: props.title,
        paragraph: props.description,
        button: (_button = button()) !== null && _button !== void 0 ? _button : /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
            name: "ctaButton"
        }),
        backgroundColor: props.backgroundColor
    });
};
var $e86c567ab983d0ac$export$2e2bcd8739ae039 = $e86c567ab983d0ac$export$386f3ec84bf404ad;

});
parcelRegister("dMM9X", function(module, exports) {

$parcel$export(module.exports, "CallToAction", function () { return (parcelRequire("kyoYi")).CallToAction; });
$parcel$export(module.exports, "HeroCarousel", function () { return (parcelRequire("5C9Aa")).HeroCarousel; });
$parcel$export(module.exports, "Logos", function () { return (parcelRequire("2Nqw3")).Logos; });
$parcel$export(module.exports, "FeaturesHighlight", function () { return (parcelRequire("3Yf2x")).FeaturesHighlight; });
$parcel$export(module.exports, "Integration", function () { return (parcelRequire("g4WuQ")).Integration; });
$parcel$export(module.exports, "MobileApp", function () { return (parcelRequire("cJh4j")).MobileApp; });
$parcel$export(module.exports, "SideNav", function () { return (parcelRequire("5STdK")).SideNav; });

var $kyoYi = parcelRequire("kyoYi");

var $55vkU = parcelRequire("55vkU");

var $3Yf2x = parcelRequire("3Yf2x");

var $gtQwZ = parcelRequire("gtQwZ");

var $5C9Aa = parcelRequire("5C9Aa");

var $g4WuQ = parcelRequire("g4WuQ");

var $2Nqw3 = parcelRequire("2Nqw3");

var $cJh4j = parcelRequire("cJh4j");

var $5STdK = parcelRequire("5STdK");

var $2p5f0 = parcelRequire("2p5f0");
parcelRequire("62VZK");
var $7CBQh = parcelRequire("7CBQh");

});
parcelRegister("kyoYi", function(module, exports) {

$parcel$export(module.exports, "CallToAction", function () { return $9844db6cec37a539$export$9438b36140854db6; });
/* call-to-action.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");
const $9844db6cec37a539$var$callToActionStyles = null;
const $9844db6cec37a539$var$typographyOverrides = null;
const $9844db6cec37a539$var$polygonStyles = null;
const $9844db6cec37a539$var$contentStyles = null;
const $9844db6cec37a539$export$9438b36140854db6 = ({ header: header, paragraph: paragraph, button: button, backgroundColor: backgroundColor = "black" })=>{
    let transformedButton;
    if (backgroundColor === "blue") transformedButton = /*#__PURE__*/ (0, $iSvIT.cloneElement)(button, {
        variant: "primary_alt"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_p12f1git _195g1wug _y3gn1h6o"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            style: {
                "--background-color": (0, $5ohHq.wacToken)(`color.primary.${backgroundColor}`)
            },
            className: (0, $esG4f.default)([
                "_11q76ulk _mkrz1q5k _1vthpg2b _1yt4koci"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    layout: "8",
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c11p5 _zulpu2gc _6rthxy5q"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                className: (0, $esG4f.default)([
                                    "_1mou78py",
                                    "h3"
                                ]),
                                style: {
                                    color: (0, $5ohHq.wacToken)("color.neutral.light0")
                                },
                                children: header
                            }),
                            paragraph && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                className: (0, $esG4f.default)([
                                    "_1mou78py",
                                    ".body-md"
                                ]),
                                style: {
                                    color: (0, $5ohHq.wacToken)("color.neutral.light0")
                                },
                                children: paragraph
                            })
                        ]
                    })
                }),
                transformedButton !== null && transformedButton !== void 0 ? transformedButton : button
            ]
        })
    });
};

});

parcelRegister("55vkU", function(module, exports) {

$parcel$export(module.exports, "CustomerTestimonials", function () { return $25af9ba243d3e879$export$ff99f9acc73d9931; });
/* customer-testimonials.tsx generated by @compiled/babel-plugin v0.28.8 */ // Initial changes from ADG4CustomerTestimonials
// Removed scroll Ref and inview tracker, since there is no longer an automatic transition to new tabs
// Removed className since it was not in use
// Removed testimonialCta since that is a non standard usage in the Confluence Product Tour and clouds the core Design Pattern
// Removed Blue as an option for backgrounds for now since that is not spec
// Removed h2 heading (that should be included as a Content Block separately going forward)
// Removed TypographyStyles wrapper for consistency with other components/patterns
// Cleaned up unused classnames within the component

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $cutM5 = parcelRequire("cutM5");

var $9Kv7x = parcelRequire("9Kv7x");

var $bhreu = parcelRequire("bhreu");

var $1UUq1 = parcelRequire("1UUq1");

var $4XrxY = parcelRequire("4XrxY");
const $25af9ba243d3e879$var$backgroundColorStyleMap = {
    black: "_bfhkr3uz",
    white: "_bfhku67f"
};
const $25af9ba243d3e879$var$backgroundShape = null;
const $25af9ba243d3e879$var$fontColorStyleMap = {
    "dark-bg": "_syaz12cp",
    "white-bg": "_syazn7od"
};
const $25af9ba243d3e879$var$topLineStyleMap = {
    black: "_bfhku67f",
    white: "_bfhkr3uz"
};
const $25af9ba243d3e879$var$logoOptionStyleMap = {
    "dark-bg": "_d4ksu67f _i862u67f _1uiy1wzc",
    "white-bg": "_d4ksr3uz _i862r3uz"
};
const $25af9ba243d3e879$var$justifyContentStyleMap = {
    "dark-bg": "_1bahh9n0",
    "white-bg": "_1bah1h6o"
};
const $25af9ba243d3e879$export$ff99f9acc73d9931 = ({ bgColor: bgColor = "black", testimonials: testimonials, productKey: productKey })=>{
    const bgTheme = bgColor === "black" ? "dark-bg" : "white-bg";
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4Tabs), {
        loop: true,
        children: /*#__PURE__*/ (0, $loA2J.jsx)("section", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswh2mm _1pbykb7n _6rth1jfw",
                    $25af9ba243d3e879$var$fontColorStyleMap[bgTheme]
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_kqswstnw _1r04idpf _1bsb1lk2 _p12fklux _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1rfm1osq",
                                    $25af9ba243d3e879$var$backgroundColorStyleMap[bgColor],
                                    bgColor === "black" && "_mkrzq8qa _kxoh75ra"
                                ])
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_1e0c11p5 _yv0ehkll _2z05hkll _1ir7idpf _bhknkb7n _1rrs1txw _s9hn1ekt _16l7kb7n _w53ccs5v"
                                ]),
                                children: testimonials.map((testimonial, index)=>{
                                    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4TabPanel), {
                                        id: `${index}`,
                                        panelIndex: index,
                                        forceRender: true,
                                        hideTabPanelRole: true,
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)($25af9ba243d3e879$var$TopRowContent, {
                                            testimonial: testimonial,
                                            index: index,
                                            bgTheme: bgTheme,
                                            bgColor: bgColor
                                        })
                                    }, index);
                                })
                            }),
                            testimonials.length > 1 && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_kqswh2mm _1e0c1txw _1p57v47k _1n261g80 _4cvr1fhb _1gde1bp4 _xsmr1h6o"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_1reo15vq _18m915vq _1bsb1osq _1bah1yb4 _1v611bp4 _476dgktf"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cutM5.Adg4DraggableTabList), {
                                        rowGap: "32px",
                                        className: (0, $esG4f.default)([
                                            "_6rth1fu0 _1q511aa3 _qtt8agmp"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_kqswstnw _152tt94y _1e02idpf _rjxpidpf _4t3it94y _2rkoyh40 _tzy4105o _xaej183y",
                                                    $25af9ba243d3e879$var$topLineStyleMap[bgColor]
                                                ])
                                            }),
                                            testimonials.map((testimonial, index)=>{
                                                return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTab), {
                                                    as: "li",
                                                    tabIndex: index,
                                                    dataEventProps: {
                                                        "data-product-key": productKey,
                                                        "data-event-component": "tab",
                                                        "data-event-container": "testimonialsSection",
                                                        "data-event": "clicked",
                                                        "data-label-english": testimonial.label
                                                    },
                                                    label: testimonial.label,
                                                    className: (0, $esG4f.default)([
                                                        $25af9ba243d3e879$var$logoOptionStyleMap[bgTheme],
                                                        "_1e0c1txw _1bah1fhb _4cvr1fhb _kqswh2mm _1atpidpf"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $loA2J.jsx)($25af9ba243d3e879$var$LogoTabContent, {
                                                        testimonialLogo: testimonial.logo
                                                    })
                                                }, index);
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
const $25af9ba243d3e879$var$TopRowContent = ({ testimonial: testimonial, index: index, bgTheme: bgTheme, bgColor: bgColor, isPanelActive: isPanelActive })=>{
    var _testimonial_link_type;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_kqswh2mm _1e0c1txw _1p57v47k _1n261g80 _4cvr1fhb _1gde1bp4 _xsmr1h6o",
            "_6rth1ylp _1e0c11p5 _yv0ewxkt _gy1pzwfg _tzy4idpf _1pbykb7n _1ph4hkll",
            isPanelActive && "_tzy4kb7n _1pbycs5v"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswh2mm _i0dlhwvj _1e0c1txw _1bah1h6o _4cvresu3 _16xt1ssb _1rfm1vuk _q5ugidpf _7tld1wug _14adidpf _4uro1wug _7bcc1n8h _18jmidpf _qji61wug _ms0lidpf _v5we1wug"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_bna7ng7t _1jtm1c95 _1fhe1c95 _1cwsdlvw _mezj1wug _v4pn1ule",
                        isPanelActive && "_m3691nt4"
                    ]),
                    children: typeof testimonial.image !== "string" && "contentType" in testimonial.image ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $9Kv7x.ContentPlatformImage), (0, $7Knp0._)({}, testimonial.image)) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                        image: {
                            src: testimonial.image,
                            alt: ""
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_i0dl1nrf _1reo15vq _18m915vq _1a8l1ssb"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _4t3i1osq _2rkogktf _kqswh2mm _19pkidpf _2hwx1wug _otyridpf _18u01wug _26vxys9h _12rr1e9y _1rfm1osq",
                        $25af9ba243d3e879$var$justifyContentStyleMap[bgTheme]
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_v5641pn7 _1e0c1txw _2lx21bp4 _zulp1tcg",
                            isPanelActive && "_y44v13sw _11vozap6"
                        ]),
                        children: [
                            testimonial.eyebrow && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                className: (0, $esG4f.default)([
                                    $25af9ba243d3e879$var$fontColorStyleMap[bgTheme],
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "eyebrow-md"
                                ]),
                                children: testimonial.eyebrow
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("blockquote", {
                                className: (0, $esG4f.default)([
                                    $25af9ba243d3e879$var$fontColorStyleMap[bgTheme],
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "callout"
                                ]),
                                children: [
                                    "\u201C",
                                    testimonial.quote,
                                    "\u201D"
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                                className: (0, $esG4f.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                        className: (0, $esG4f.default)([
                                            $25af9ba243d3e879$var$fontColorStyleMap[bgTheme],
                                            "eyebrow-lg"
                                        ]),
                                        children: testimonial.name
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                        className: (0, $esG4f.default)([
                                            $25af9ba243d3e879$var$fontColorStyleMap[bgTheme],
                                            "body-md title"
                                        ]),
                                        children: testimonial.title
                                    })
                                ]
                            }),
                            testimonial.link ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                anchorProps: {
                                    tabIndex: isPanelActive ? 0 : -1
                                },
                                text: testimonial.link.text,
                                href: testimonial.link.url,
                                type: (_testimonial_link_type = testimonial.link.type) !== null && _testimonial_link_type !== void 0 ? _testimonial_link_type : "primary",
                                bgColor: bgColor === "black" ? "bgBlackBlue" : "bgWhite",
                                dataEventProps: testimonial.link.dataEventProps
                            }) : null
                        ]
                    }, index)
                })
            })
        ]
    });
};
const $25af9ba243d3e879$var$topRowActiveStyle = null;
const $25af9ba243d3e879$var$customerImagesImgActiveStyle = null;
const $25af9ba243d3e879$var$quoteContainerActiveStyle = null;
const $25af9ba243d3e879$var$LogoTabContent = ({ testimonialLogo: testimonialLogo, isSelected: isSelected = false })=>{
    const isContentfulImage = "contentType" in testimonialLogo;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_tzy4kb7n _kqswstnw _152tj39m _1e02idpf _rjxpidpf _4t3i14y2 _2rkoyh40",
                    "top-marker"
                ])
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_11q7glyw _19itidpf _r06hglyw _1q51gktf _80omtlke _kqswh2mm"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                    className: (0, $esG4f.default)([
                        "_tzy4105o _v5641bs3 _16l4kb7n",
                        "_4t3i1u1b _1e0c1txw _4cvr1h6o",
                        isSelected && "_tzy4kb7n"
                    ]),
                    children: isContentfulImage ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $9Kv7x.ContentPlatformImage), (0, $6iHNw._)((0, $7Knp0._)({}, testimonialLogo), {
                        width: "140",
                        height: "34",
                        style: {
                            objectFit: "contain",
                            objectPosition: "center center"
                        },
                        className: "tab-logo"
                    })) : testimonialLogo
                })
            })
        ]
    });
}; // LogoTabContent styles
const $25af9ba243d3e879$var$logoImgStyle = null;
const $25af9ba243d3e879$var$logoImgSelectedStyle = null;
const $25af9ba243d3e879$var$logoButtonStyle = null;
const $25af9ba243d3e879$var$topMarkerStyle = null;
const $25af9ba243d3e879$var$logoImgContainerStyle = null; // ADG4CustomerTestimonials styles
const $25af9ba243d3e879$var$topLineStyles = null;
const $25af9ba243d3e879$var$testimonialKeyframeStyles = null;
const $25af9ba243d3e879$var$rowWidthStyle = null;
const $25af9ba243d3e879$var$topRowStyle = null;
const $25af9ba243d3e879$var$bgShapeStyle = null;
const $25af9ba243d3e879$var$customerImagesSectionStyles = null;
const $25af9ba243d3e879$var$customerImagesSectionImageStyles = null;
const $25af9ba243d3e879$var$customerQuotesSectionStyle = null;
const $25af9ba243d3e879$var$testimonialQuotesSectionStyle = null;
const $25af9ba243d3e879$var$quoteContainerStyle = null;
const $25af9ba243d3e879$var$quoteContainerPStyle = null;
const $25af9ba243d3e879$var$logosContainerBaseStyle = null;
const $25af9ba243d3e879$var$logosStyle = null;
const $25af9ba243d3e879$var$logoOptionStyle = null;
const $25af9ba243d3e879$var$testimonialStyles = null;
const $25af9ba243d3e879$var$tabPanelWrapperStyles = null;

});
parcelRegister("9Kv7x", function(module, exports) {

$parcel$export(module.exports, "ContentPlatformImage", function () { return $ecf502f0947f1c39$export$f8e4eb6f7b9af79c; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $bhreu = parcelRequire("bhreu");
const $ecf502f0947f1c39$export$f8e4eb6f7b9af79c = (_param)=>{
    var { contentType: contentType, src: src, alt: alt, baseWidth: baseWidth } = _param, rest = (0, $akGnX._)(_param, [
        "contentType",
        "src",
        "alt",
        "baseWidth"
    ]);
    const queryPairs = [];
    let srcSet = [];
    if (contentType === "image/png") {
        queryPairs.push("fm=webp");
        if (baseWidth) {
            srcSet = (0, $bhreu.getSrcSet)(src, baseWidth, queryPairs, "w");
            queryPairs.push(`w=${baseWidth}`);
        }
    }
    const queryString = queryPairs.length > 0 ? `?${queryPairs.join("&")}` : "";
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $loA2J.jsx)("img", (0, $6iHNw._)((0, $7Knp0._)({
        loading: "lazy"
    }, rest), {
        src: `${src}${queryString}`,
        srcSet: srcSet.length > 0 ? srcSet.join(",") : undefined,
        alt: alt
    })));
};

});


parcelRegister("3Yf2x", function(module, exports) {

$parcel$export(module.exports, "FeaturesHighlight", function () { return $a5d0df8bfd42a304$export$bf20c48d528647dd; });
/* features-highlight.tsx generated by @compiled/babel-plugin v0.28.8 */ // import type {
//     MouseEvent as ReactMouseEvent,
//     TouchEvent as ReactTouchEvent,
//     KeyboardEvent as ReactKeyboardEvent
// } from "react";
// import { useRef, useEffect, useState, useCallback } from "react";

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $vqrsL = parcelRequire("vqrsL");

var $bhreu = parcelRequire("bhreu");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");
const $a5d0df8bfd42a304$export$bf20c48d528647dd = (props)=>{
    const [activeFeature, setActiveFeature] = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useState(0);
    const onFeatureSelect = (featureKey)=>{
        setActiveFeature(featureKey);
    };
    const singleFeature = (content, featureKey)=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            onClick: ()=>onFeatureSelect(featureKey),
            onKeyDown: (e)=>{
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onFeatureSelect(featureKey);
                }
            },
            className: (0, $esG4f.default)([
                "_80omtlke _kqswh2mm _u5ggpxbi _11xx17la _uoz5x71z _suga1ule _1ah31y44",
                `feature ${activeFeature === featureKey ? "selected" : ""}`
            ]),
            role: "tab",
            tabIndex: 0,
            style: {
                "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
            },
            children: [
                activeFeature === featureKey && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_kqswstnw _1pbykb7n _bfhk17la _2rko1y44 _1bsb1osq _4t3iftgi _165t1osq _glteftgi"
                    ]),
                    style: {
                        "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                    }
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_owpupxbi _6ssjpxbi"
                    ]),
                    children: content
                })
            ]
        });
    const feature1Text = /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.ContentBlock), {
        title: props.feature1Title,
        titleAs: "h3",
        text: props.feature1Body,
        eyebrow: props.feature1Eyebrow,
        alignment: "start"
    });
    var _props_feature1ImageAltText;
    const feature1Image = /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: props.feature1ImageSrc,
            alt: (_props_feature1ImageAltText = props.feature1ImageAltText) !== null && _props_feature1ImageAltText !== void 0 ? _props_feature1ImageAltText : "",
            style: {
                width: "100%",
                height: "auto"
            }
        },
        style: {
            width: "100%",
            height: "auto"
        }
    });
    const feature2Text = /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.ContentBlock), {
        title: props.feature2Title,
        titleAs: "h3",
        text: props.feature2Body,
        eyebrow: props.feature2Eyebrow,
        alignment: "start"
    });
    var _props_feature2ImageAltText;
    const feature2Image = /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: props.feature2ImageSrc,
            alt: (_props_feature2ImageAltText = props.feature2ImageAltText) !== null && _props_feature2ImageAltText !== void 0 ? _props_feature2ImageAltText : "",
            style: {
                width: "100%",
                height: "auto"
            }
        },
        style: {
            width: "100%",
            height: "auto"
        }
    });
    const feature3Text = /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.ContentBlock), {
        title: props.feature3Title,
        titleAs: "h3",
        text: props.feature3Body,
        eyebrow: props.feature3Eyebrow,
        alignment: "start"
    });
    var _props_feature3ImageAltText;
    const feature3Image = /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: props.feature3ImageSrc,
            alt: (_props_feature3ImageAltText = props.feature3ImageAltText) !== null && _props_feature3ImageAltText !== void 0 ? _props_feature3ImageAltText : "",
            style: {
                width: "100%",
                height: "auto"
            }
        },
        style: {
            width: "100%",
            height: "auto"
        }
    });
    const featureTexts = [
        feature1Text,
        feature2Text,
        props.feature3Title && feature3Text
    ];
    const images = [
        feature1Image,
        feature2Image,
        props.feature3Title && feature3Image
    ];
    const sectionContainerStyles = null;
    const topContentContainerStyles = null;
    const featuresContainerStyles = null;
    const imageContainerStyles = null;
    const navDotsContainerStyles = null;
    const navDot = (featureNum)=>{
        return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1bsbftgi _4t3iftgi _2rko1y44 _bfhk1cls"
            ]),
            style: {
                "--_1lhuu6n": (0, $43MIc.default)(featureNum === activeFeature ? (0, $5ohHq.wacToken)("color.primary.black") : (0, $5ohHq.wacToken)("color.neutral.light500"))
            }
        });
    }; // @ts-ignore
    const navDotsContainer = (_)=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _zulppxbi _1bah1h6o _1q51pxbi"
            ]),
            children: featureTexts.map((_, index)=>navDot(index))
        });
    const mobileCarouselContainerStyles = null;
    const sliderSettings = {
        dots: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        afterChange: (current)=>setActiveFeature(current),
        appendDots: navDotsContainer
    };
    const featureSlideStyles = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_15fl1wug _1d2w1wug _1svy1wug _seov1wug _16imoahv _b8yq1osq _14b51osq _su071wqb _1j8bcx6w _181n11p5 _dwk3usvi _19wg14hz _11mz1tcg _owpu1wqb _10jxzqdx _1vsw1vi7 _suga1txw _1gde1bp4 _1rfm1osq _tnru1osq _8164pxbi _133i1jfw"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1rfm1osq _xlt11ejb _s51szwfg _uoz5179g _1e3ceqnf _1e0c1txw _2lx21bp4 _zulpu2gc _4cvr1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.ContentBlock), {
                        title: props.title,
                        titleAs: "h2",
                        text: props.description,
                        alignment: "center"
                    }),
                    props.linkText && props.linkHref && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                        text: props.linkText,
                        href: props.linkHref
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                role: "tablist",
                className: (0, $esG4f.default)([
                    "_1e3cx71z _dm251txw _1ini1bp4 _kzvi1bgi _1e0cglyw"
                ]),
                children: featureTexts.map((feature, index)=>singleFeature(feature, index))
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                role: "tabpanel",
                className: (0, $esG4f.default)([
                    "_1e3cthi2 _165t1osq _uoz5uufb _sugaglyw"
                ]),
                children: images[activeFeature]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0cglyw _suga1ule",
                    "_vnijh2mm _1ls01ule _1dtvusvi _1kb1glyw _fjwtglyw _1wv2glyw _1r6vglyw _zookglyw _8rkdglyw _1tpbmuzh _u8dlmuzh _e1ct1j28 _1t25h2mm _ll151ule _8lsh15vq _kuv715vq _19moidpf _1vqqidpf _m8oxidpf _bzd2idpf _zwvbidpf _19wzidpf _2awfidpf _l1guidpf _3otn1r31 _1d59glyw _r3kx1o36 _1y6utlke _1t6x161g _1u6z161g _1vpa161g _5skb161g _1xca161g _xcl1161g _rzx1161g _1xcr161g _57of161g _b29h161g _snlxh2mm _1rfpidpf _104oidpf _j6fg1ule _gkdh1wug _1jbo1wug _1qa65mfb _r4f35mfb _y1t8b3bt _1v9lb3bt _v42h1hrf _1t4e15vq _1u35glyw _1vrb1e5h _m8yv1osq _gzcot94y _tovh1txw _160x1h6o _1a23usic _k4vw1ule _19i1glyw _1afyglyw _1xnx1ule _qzmo15vq _1xzb1ule _ntpm1wug _4v68okh7 _13h3glyw",
                    "slider-container"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($vqrsL))), (0, $6iHNw._)((0, $7Knp0._)({}, sliderSettings), {
                    children: featureTexts.map((feature, index)=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_18zrzwfg _1e0c1txw _2lx21bp4 _zulppxbi"
                            ]),
                            children: [
                                singleFeature(feature, index),
                                images[index]
                            ]
                        }, index))
                }))
            })
        ]
    });
};
// Source https://github.com/kenwheeler/slick/blob/master/slick/slick.css
const $a5d0df8bfd42a304$var$slickStyle = null;

});

parcelRegister("gtQwZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $359d438096babc01$export$2e2bcd8739ae039; });
/* hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $lbVpk = parcelRequire("lbVpk");

var $c4STr = parcelRequire("c4STr");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");
const $359d438096babc01$export$887967f05dc521ae = (_param)=>{
    var { layout: layout = "image-right" } = _param, props = (0, $akGnX._)(_param, [
        "layout"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        style: {
            "--background-color": `${props.backgroundColor ? (0, $5ohHq.wacToken)(props.backgroundColor) : "transparent"}`
        },
        className: (0, $esG4f.default)([
            "_11q76ulk"
        ]),
        children: layout === "image-both" ? /*#__PURE__*/ (0, $loA2J.jsx)($359d438096babc01$var$HeroBothImages, (0, $7Knp0._)({
            layout: layout
        }, props)) : /*#__PURE__*/ (0, $loA2J.jsx)($359d438096babc01$var$HeroOneImage, (0, $7Knp0._)({
            layout: layout
        }, props))
    });
};
var $359d438096babc01$export$2e2bcd8739ae039 = $359d438096babc01$export$887967f05dc521ae;
const $359d438096babc01$var$DARK_BKGD_COLORS = [
    "color.primary.black"
];
const $359d438096babc01$var$HeadingContent = ({ heading: heading, subheading: subheading, callToActionProps: callToActionProps, size: size = "regular", backgroundColor: backgroundColor })=>{
    const _ref = callToActionProps !== null && callToActionProps !== void 0 ? callToActionProps : {}, { text: buttonText } = _ref, buttonProps = (0, $akGnX._)(_ref, [
        "text"
    ]);
    const isLarge = size === "large";
    const useLightText = backgroundColor ? $359d438096babc01$var$DARK_BKGD_COLORS.includes(backgroundColor) : false;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                style: {
                    color: useLightText ? (0, $5ohHq.wacToken)("color.neutral.light0") : "inherit"
                },
                className: (0, $esG4f.default)([
                    "_18s8ze3t",
                    isLarge ? "superhero" : undefined
                ]),
                children: heading
            }),
            subheading && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_6rthze3t",
                    isLarge ? "body-lg" : "body-md"
                ]),
                style: {
                    color: useLightText ? (0, $5ohHq.wacToken)("color.neutral.light0") : "inherit"
                },
                children: subheading
            }),
            buttonText && buttonProps && /*#__PURE__*/ (0, $loA2J.jsx)((0, $lbVpk.Button), (0, $6iHNw._)((0, $7Knp0._)({}, buttonProps), {
                size: "large",
                className: (0, $esG4f.default)([
                    "_1pfhxy5q"
                ]),
                children: buttonText
            }))
        ]
    });
};
const $359d438096babc01$var$HeroOneImage = (_param)=>{
    var { layout: layout = "image-right", imageProps: imageProps } = _param, props = (0, $akGnX._)(_param, [
        "layout",
        "imageProps"
    ]);
    var _imageProps_alt;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
        layout: "12",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c11p5 _zulp1ejb _1rjc1jfw _y3gn1h6o _4cvr1h6o _1j8bwxkt _lagd18l3 _19wgxy5q _uj6kv2br _1ooboahv _1s0lxncg"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        layout === "image-left" && "_1b1qcs5v"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)($359d438096babc01$var$HeadingContent, (0, $7Knp0._)({}, props))
                }),
                imageProps && /*#__PURE__*/ (0, $loA2J.jsx)((0, $c4STr.Image), {
                    maxPossibleWidth: 700,
                    src: imageProps.src,
                    alt: (_imageProps_alt = imageProps.alt) !== null && _imageProps_alt !== void 0 ? _imageProps_alt : "",
                    loading: "eager",
                    width: imageProps.width,
                    height: imageProps.height
                })
            ]
        })
    });
};
const $359d438096babc01$var$gridStyle = null;
const $359d438096babc01$var$headingStyle = null;
const $359d438096babc01$var$imageStartStyle = null;
const $359d438096babc01$var$bodyStyle = null;
const $359d438096babc01$var$buttonStyle = null; /*
                          This is an experimental start to support the needs of the Hero variation with images on the sides, primary content centered
                          Initial support is seens on Product enterprise pages (such as /software/jira/enterprise) as served by WAC Authoring Engine
                          
                          TODO: We need to understand the levels of configurability desired/needed to support a variety of use cases, collab with design.
                            Currently it is very tailored to the aforementioned enterprise experience
                          */ 
const $359d438096babc01$var$HeroBothImages = (_param)=>{
    var { imageProps: imageProps, secondaryImageProps: secondaryImageProps } = _param, props = (0, $akGnX._)(_param, [
        "imageProps",
        "secondaryImageProps"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1reo15vq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
            layout: "12",
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_uaqo1x3a _13j917im",
                    "_kqswh2mm _1e0c11p5 _10fp1h6o _y3gn1h6o _4cvr1h6o _6a6z1h6o _1rjc1jfw _14b51ssb _su07u2gc _1ooboahv _1s0lxncg _bxthb3bt _t4hxstnw _1yp51osq _1bpvsmen _brhgmgnk _5kbx1f51 _1gg8w2la _n4lfidpf _1nls12it _14xsidpf _16bh12it _1z0y9by0 _ixsu1osq _a6uwb3bt _dbttstnw _83tk1wn5 _10wjmgnk _tzs91f51 _wi3i1048 _1x65idpf _oppa12it _1ohy1kly _nd8fidpf _1yam12it _ugza1kly _mlxy9by0 _k4z51osq _xcpbpwvu"
                ]),
                style: {
                    "--_1thiznr": (0, $43MIc.default)(imageProps ? `url(${imageProps.src})` : "none"),
                    "--_c31b9r": (0, $43MIc.default)(secondaryImageProps ? `url(${secondaryImageProps.src})` : "none")
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)($359d438096babc01$var$HeadingContent, (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                    size: "regular"
                }))
            })
        })
    });
};
const $359d438096babc01$var$gridTwoImagesStyle = null;

});

parcelRegister("5C9Aa", function(module, exports) {

$parcel$export(module.exports, "HeroCarousel", function () { return $47d867af5ed4b3f4$export$b92905002f03c113; });
/* hero-carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $eDoPe = parcelRequire("eDoPe");
parcelRequire("isSvf");
var $lxS8L = parcelRequire("lxS8L");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $lbVpk = parcelRequire("lbVpk");

var $1O6nN = parcelRequire("1O6nN");
const $47d867af5ed4b3f4$export$b92905002f03c113 = ({ tabsData: tabsData })=>{
    const [selectedTab, setSelectedTab] = (0, $iSvIT.useState)(0);
    const listRef = (0, $iSvIT.useRef)(null);
    const { ref: lastTabRef, inView: isTabListEndVisible } = (0, $eDoPe.useInView)({
        root: listRef === null || listRef === void 0 ? void 0 : listRef.current,
        threshold: 1
    });
    const { ref: firstTabRef, inView: isTabListStartVisible } = (0, $eDoPe.useInView)({
        root: listRef === null || listRef === void 0 ? void 0 : listRef.current,
        threshold: 1
    });
    (0, $iSvIT.useEffect)(()=>{
        const listElement = listRef === null || listRef === void 0 ? void 0 : listRef.current;
        if (listElement) {
            var _listElement_children;
            const tabElement = (_listElement_children = listElement.children) === null || _listElement_children === void 0 ? void 0 : _listElement_children[selectedTab + 1];
            if (tabElement && typeof tabElement.scrollIntoView === "function") {
                tabElement.scrollIntoView({
                    behavior: "smooth",
                    inline: "center",
                    block: "end"
                });
                tabElement.focus();
            }
        }
    }, [
        selectedTab
    ]);
    const onKeyDown = (e)=>{
        if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
            let newFocusIndex = 0;
            if (e.key === "ArrowRight") {
                newFocusIndex = selectedTab + 1;
                if (newFocusIndex >= tabsData.length) newFocusIndex = 0;
            } else if (e.key === "ArrowLeft") {
                newFocusIndex = selectedTab - 1; // If we're at the start, move to the end
                if (newFocusIndex < 0) newFocusIndex = tabsData.length - 1;
            }
            setSelectedTab(newFocusIndex);
        }
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        id: "hero-carousel",
        "data-testid": "hero-carousel",
        className: (0, $esG4f.default)([
            "_1bsb1osq _1reo15vq _18m915vq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _2lx21sxn _1bsb1osq _1reo15vq _18m915vq"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)($47d867af5ed4b3f4$var$TabList, {
                    listRef: listRef,
                    isTabListViewable: isTabListStartVisible && isTabListEndVisible,
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            ref: firstTabRef
                        }),
                        tabsData.map((tab, i)=>/*#__PURE__*/ (0, $loA2J.jsxs)($47d867af5ed4b3f4$var$Tab, {
                                isSelected: i === selectedTab,
                                id: tab.id,
                                onClick: ()=>{
                                    setSelectedTab(i);
                                },
                                onKeyDown: onKeyDown,
                                children: [
                                    tab.eyebrow && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                        className: (0, $esG4f.default)([
                                            "_syaz121t _y3gnv2br _19pkidpf _2hwxidpf _otyridpf _18u0idpf _tzy4105o _v564177f",
                                            "eyebrow-sm"
                                        ]),
                                        style: {
                                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                                        },
                                        children: tab.eyebrow
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                        className: (0, $esG4f.default)([
                                            "_syaz121t _y3gnv2br _19pkidpf _2hwxidpf _otyridpf _18u0idpf _tzy4105o _v564177f",
                                            "_1wyb19as _k48p16tn _vwz41xr0"
                                        ]),
                                        style: {
                                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                                        },
                                        children: tab.title
                                    })
                                ]
                            }, tab.id)),
                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            ref: lastTabRef
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)($47d867af5ed4b3f4$var$PanelContainer, {
                    children: tabsData.map((tab, i)=>/*#__PURE__*/ (0, $loA2J.jsx)($47d867af5ed4b3f4$var$Panel, {
                            isSelected: i === selectedTab,
                            id: tab.id,
                            panel: tab.panel,
                            titleAs: i === 0 ? "h1" : "h2"
                        }, tab.id))
                })
            ]
        })
    });
};
var $47d867af5ed4b3f4$export$2e2bcd8739ae039 = $47d867af5ed4b3f4$export$b92905002f03c113;
const $47d867af5ed4b3f4$var$TabList = ({ children: children, listRef: listRef, isTabListViewable: isTabListViewable })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_11q71hlo _1bsb1osq _syazcd5j _1reo15vq _18m915vq _18zrzwfg _su071wqb"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div" // @ts-ignore
        , {
            ref: listRef,
            tabIndex: -1,
            role: "tablist",
            className: (0, $esG4f.default)([
                "_1tkegad4 _1e0c1txw _qtt8glyw _1mouidpf _195g1wug _18zridpf _1rjcie5z _1reo15zi _rjfvx6dd _b8yqzqdx _zcekze3t _kpfhglyw",
                isTabListViewable && "_1bah1h6o"
            ]),
            children: children
        })
    });
};
const $47d867af5ed4b3f4$var$Tab = ({ children: children, isSelected: isSelected, id: id, onClick: onClick, onKeyDown: onKeyDown })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("button", {
        type: "button",
        tabIndex: isSelected ? 0 : -1,
        role: "tab",
        "aria-selected": isSelected ? "true" : "false",
        "aria-controls": `hero-panel-${id}`,
        id: `hero-tab-${id}`,
        onClick: onClick,
        onKeyDown: onKeyDown,
        "data-label": `hero-tab-${id}`,
        className: (0, $esG4f.default)([
            "_mqm21kma _v564ucvz _179rglyw _h7alglyw _r06hglyw _bfhk1j28 _ect41kw7 _1wyb1j6v _1bsb1ltq _1ul91ltq _80omtlke _1hu1v2br _1rjcu2gc _18zr1ejb _4cvrv2br _1e0c1txw _2lx21bp4 _zulp12x7 _ihhukb7n _n41hkb7n",
            isSelected && "_mqm21hn9 _1mrhkb7n"
        ]),
        style: {
            "--_1vwzriw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.yellow"))
        },
        children: children
    });
};
const $47d867af5ed4b3f4$var$PanelContainer = ({ children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c11p5"
        ]),
        children: children
    });
};
const $47d867af5ed4b3f4$var$Panel = (_param)=>{
    var { isSelected: isSelected, id: id, panel: panel } = _param, props = (0, $akGnX._)(_param, [
        "isSelected",
        "id",
        "panel"
    ]);
    var _panel_secondaryCallToAction, _panel_bgImage, _panel_secondaryCallToAction1;
    const [isModalOpen, setIsModalOpen] = (0, $iSvIT.useState)(false);
    const baseStyle = null;
    const isVideoLink = ((_panel_secondaryCallToAction = panel.secondaryCallToAction) === null || _panel_secondaryCallToAction === void 0 ? void 0 : _panel_secondaryCallToAction.type) === "video";
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        role: "tabpanel",
        id: `hero-panel-${id}`,
        "data-testid": `hero-panel-${id}`,
        "aria-hidden": !isSelected,
        "aria-labelledby": `hero-tab-${id}`,
        className: (0, $esG4f.default)([
            "_v564twcc _yyhy183o _1ii7183o _1e0c11p5 _tzy4idpf _1pby1mrw _kqswh2mm",
            isSelected && "_tzy4kb7n _1pbykb7n",
            "_1kt9b3bt _1g0v1mrw _1cs8stnw _1tesidpf _1rusu6yl _aetrb3bt _1bqq1mrw _18postnw _16gxidpf _z0ai1osq _wbcj14i6 _1kje1h6o _1hfku6yl _1a1fdirt _19h91dfr _z0bc12wd"
        ]),
        style: {
            "--bg-color": panel.bgColor === "neutral" ? (0, $5ohHq.wacToken)(`color.neutral.light200`) : (0, $5ohHq.wacToken)(`color.primary.${panel.bgColor}`),
            "--_1gk99st": (0, $43MIc.default)(((_panel_bgImage = panel.bgImage) === null || _panel_bgImage === void 0 ? void 0 : _panel_bgImage.lg) ? `url(${panel.bgImage.lg})` : undefined),
            "--_xe4ghn": (0, $43MIc.default)(panel.layout === "end" ? "0% 50%" : "center center")
        },
        children: [
            isVideoLink && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Modal), {
                isOpen: isModalOpen,
                closeModal: ()=>{
                    setIsModalOpen(false);
                },
                closeLabel: "Close video",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $lxS8L.Video), {
                    muted: false,
                    videoType: "mp4",
                    videoLink: (_panel_secondaryCallToAction1 = panel.secondaryCallToAction) === null || _panel_secondaryCallToAction1 === void 0 ? void 0 : _panel_secondaryCallToAction1.href
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_yyhy183o _1ii7183o _18zrzwfg _1rjcxncg _1e0c11p5 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulp1ejb _1qon1h6o _1lb81h6o _5qqy1h6o _su071wqb _1rqtcx6w _pdlmxy5q _10jxzqdx",
                    panel.layout === "end" ? "_1uyy1d44 _1cxzv2br _10wbv2br _s0n3v2br" : panel.layout === "start" ? "_1uyy1vi5 _1cxzv2br _10wbv2br _s0n3v2br" : "_1uyyeqnf"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)($47d867af5ed4b3f4$var$PanelContent, {
                        panel: panel,
                        titleAs: props.titleAs
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($47d867af5ed4b3f4$var$PanelActions, (0, $6iHNw._)((0, $7Knp0._)({}, panel), {
                        onVideoClick: isVideoLink ? (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            setIsModalOpen(true);
                        } : undefined
                    }))
                ]
            })
        ]
    });
};
const $47d867af5ed4b3f4$var$PanelContent = (_param)=>{
    var { panel: panel } = _param, props = (0, $akGnX._)(_param, [
        "panel"
    ]);
    // We need to think about this more holistically going forward, instead of on a per component level
    const isForegroundLight = [
        "blue",
        "black"
    ].includes(panel.bgColor);
    const { titleAs: Title = "h2" } = props;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)(Title, {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                    isForegroundLight && "_syaz121t",
                    "h1"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: panel.title
            }),
            panel.body && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                    isForegroundLight && "_syaz121t",
                    "body-lg"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: panel.body
            })
        ]
    });
};
const $47d867af5ed4b3f4$var$PanelActions = (panel)=>{
    return panel && /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1h6o _1n261g80 _zulp1ejb",
            (panel.layout === "start" || panel.layout === "end") && "_msupv2br"
        ]),
        children: [
            panel.primaryCallToAction && /*#__PURE__*/ (0, $loA2J.jsx)($47d867af5ed4b3f4$var$PrimaryCallToAction, (0, $7Knp0._)({
                bgColor: panel.bgColor
            }, panel.primaryCallToAction)),
            panel.secondaryCallToAction && /*#__PURE__*/ (0, $loA2J.jsx)($47d867af5ed4b3f4$var$SecondaryCallToAction, (0, $7Knp0._)({}, panel))
        ]
    });
};
const $47d867af5ed4b3f4$var$PrimaryCallToAction = (props)=>{
    const { bgColor: bgColor } = props, rest = (0, $akGnX._)(props, [
        "bgColor"
    ]);
    let variant = "primary";
    if (bgColor === "blue") variant = "primary_alt";
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lbVpk.Button), (0, $6iHNw._)((0, $7Knp0._)({}, rest), {
        variant: variant,
        "data-testid": "primary-cta",
        children: props.text
    }));
};
const $47d867af5ed4b3f4$var$SecondaryCallToAction = (panel)=>{
    const { secondaryCallToAction: secondaryCallToAction } = panel;
    const bgColor = [
        "blue",
        "black"
    ].includes(panel.bgColor) ? "bgBlackBlue" : "bgWhite";
    return(// @ts-ignore
    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1O6nN.Link), (0, $6iHNw._)((0, $7Knp0._)({}, secondaryCallToAction), {
        bgColor: bgColor,
        anchorProps: {
            "data-testid": "secondary-cta"
        },
        onClick: panel.onVideoClick
    })));
};
const $47d867af5ed4b3f4$var$sectionStyles = null;
const $47d867af5ed4b3f4$var$tabListStyle = null;
const $47d867af5ed4b3f4$var$scrollableStyle = null;
const $47d867af5ed4b3f4$var$fittableStyle = null;
const $47d867af5ed4b3f4$var$tabStyle = null;
const $47d867af5ed4b3f4$var$tabTextStyle = null; /* Need to refactor our default typography to reduce need for important on a classless paragraph */ 
const $47d867af5ed4b3f4$var$tabTitleStyle = null;
const $47d867af5ed4b3f4$var$tabSelectedStyle = null;
const $47d867af5ed4b3f4$var$panelContainerStyle = null;
const $47d867af5ed4b3f4$var$panelStyle = null;
const $47d867af5ed4b3f4$var$panelSelectedStyle = null;
const $47d867af5ed4b3f4$var$panelDetailsStyle = null;
const $47d867af5ed4b3f4$var$panelEndStyle = null;
const $47d867af5ed4b3f4$var$panelStartStyle = null;
const $47d867af5ed4b3f4$var$panelCenteredStyle = null;
const $47d867af5ed4b3f4$var$detailsTextStyle = null;
const $47d867af5ed4b3f4$var$panelColorStyle = null;
const $47d867af5ed4b3f4$var$actionContainerStyle = null;
const $47d867af5ed4b3f4$var$actionStartStyle = null;

});
parcelRegister("isSvf", function(module, exports) {
$parcel$export(module.exports, "Video", function () { return (parcelRequire("lxS8L")).Video; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("lxS8L")).Video; });

var $lxS8L = parcelRequire("lxS8L");

});
parcelRegister("lxS8L", function(module, exports) {

$parcel$export(module.exports, "Video", function () { return $ed253e67f972fd3a$export$ae01dedf5c052bb; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
const $ed253e67f972fd3a$var$videoStyle = (ratio)=>{
    const aspectRatioCSS = ratio && ratio !== "none" ? {
        aspectRatio: ratio,
        objectFit: "cover"
    } : {};
    return (0, $7Knp0._)({
        maxWidth: "100%"
    }, aspectRatioCSS);
};
const $ed253e67f972fd3a$export$ae01dedf5c052bb = ({ videoLink: videoLink, videoType: videoType, videoPreviewImage: videoPreviewImage, loop: loop = true, muted: muted = true, aspectRatio: aspectRatio, alternativeSources: alternativeSources, className: className, fallbackText: fallbackText, onEnded: onEnded, children: children })=>{
    const videoRef = (0, $iSvIT.useRef)(null);
    // reload video player if video source prop changes dynamically
    (0, $iSvIT.useEffect)(()=>{
        var _videoRef_current;
        (_videoRef_current = videoRef.current) === null || _videoRef_current === void 0 ? void 0 : _videoRef_current.load();
    }, [
        videoLink
    ]);
    return(// eslint-disable-next-line jsx-a11y/media-has-caption
    /*#__PURE__*/ (0, $loA2J.jsxs)("video", {
        playsInline: true,
        muted: muted,
        preload: "auto",
        poster: videoPreviewImage,
        autoPlay: true,
        className: className,
        style: $ed253e67f972fd3a$var$videoStyle(aspectRatio),
        loop: loop,
        ref: videoRef,
        onEnded: onEnded,
        children: [
            fallbackText,
            /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                src: videoLink,
                type: `video/${videoType ? videoType : "mp4"}`
            }),
            alternativeSources ? alternativeSources.map((source, index)=>{
                return /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                    src: source.videoLink,
                    type: `video/${source.videoType ? source.videoType : "mp4"}`
                }, index);
            }) : null,
            children
        ]
    }));
};

});



parcelRegister("g4WuQ", function(module, exports) {

$parcel$export(module.exports, "Integration", function () { return $edab1f6e8003d45e$export$8912007324034abd; });
/* integration.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");
const $edab1f6e8003d45e$var$logoSizes = {
    regular: {
        size: "78px",
        cornerRadius: "18.7px"
    },
    large: {
        size: "100px",
        cornerRadius: "24px"
    }
};
const $edab1f6e8003d45e$var$IntegrationLogo = (props)=>{
    const logoListItemStyles = null;
    const logoLinkStyles = null;
    const logoImageContainerStyles = null;
    if (!props.href) return null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("li", {
        className: (0, $esG4f.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _80omtlke _1bsbcae7 _4t3icae7 _bfhkcd5j _19it1k0a _2rko13r7 _gltef22m _165tf22m _2oz41w8s _1dbz1cd0"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
            "--_1lmj1bv": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light300")),
            "--_1jpuyj7": (0, $43MIc.default)($edab1f6e8003d45e$var$logoSizes[props.logoSize].size),
            "--_1k7rxgg": (0, $43MIc.default)($edab1f6e8003d45e$var$logoSizes[props.logoSize].cornerRadius)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("a", {
            href: props.href,
            className: (0, $esG4f.default)([
                "_1e0c1txw _4t3i1osq _1bsb1osq _4cvr1h6o _1bah1h6o _1yt4u2gc"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbsq37 _4t3isbdl"
                ]),
                style: {
                    "--_1hn5070": (0, $43MIc.default)(props.width ? `${props.width}px` : "100%"),
                    "--_1jk4xy3": (0, $43MIc.default)(props.width ? "auto" : "100%")
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                    src: props.src,
                    alt: props.alt,
                    style: {
                        width: "100%",
                        height: "100%",
                        objectFit: "contain"
                    }
                })
            })
        })
    });
};
const $edab1f6e8003d45e$export$8912007324034abd = ({ eyebrow: eyebrow, title: title, titleAs: titleAs = "h3", body: body, linkLabel: linkLabel, linkHref: linkHref, logos: logos, background: background = "polygon", backgroundColor: backgroundColor = "neutral.light100", flipLayout: flipLayout = false })=>{
    const numLogos = logos.filter((logo)=>{
        var _logo_href;
        return (_logo_href = logo.href) !== null && _logo_href !== void 0 ? _logo_href : false;
    }).length;
    const logoSize = numLogos <= 6 ? "large" : "regular";
    const responsiveSectionDividerHeightsStyles = null;
    const sectionStyles = null;
    const polygonStyles = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1bsb1osq _kqswh2mm _1moul8wr _11q7fulm _1rjcq9zu",
            "_9luy1wqb _ce5au29b _wfa7llbu"
        ]),
        style: {
            "--_pxzrua": (0, $43MIc.default)(background === "full" ? 0 : "var(--ds-space-800, 64px)"),
            "--_1sgx88i": (0, $43MIc.default)(background === "full" ? (0, $5ohHq.wacToken)(`color.${backgroundColor}`) : "transparent")
        },
        children: [
            background === "polygon" && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_11q71xvm _kqswstnw _1bsb1osq _4t3imhst _14b5zqdx _b8yq87gh _1e021ssb _t9eczr6s _1kt9b3bt _1cs8stnw _iajm14o7 _kfgtq9zu _1mp41osq _1s6k1xvm _tgsmcdv4 _aetrb3bt _18postnw _1qdgq9zu _19nq1osq _z0ai1osq _16r21xvm _1oj41mhh"
                ]),
                style: {
                    "--_vp2za": (0, $43MIc.default)((0, $5ohHq.wacToken)(`color.${backgroundColor}`))
                }
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_195g1wug _p12f1osq _1bsb1osq _kqswh2mm _1pbykb7n _13ltwklj _bozgzwfg _y4tizwfg _qwmh1wqb _yu8o1wqb _1j8bwxkt _1vsw1vi7 _d2ik1wqb _exxm1wqb _10jxzqdx _1e0c11p5 _vchhusvi _zulp14hz _1dsl1tcg _4t3i1osq _4cvr1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _1n261g80 _p12f1to9 _195g1wug _2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bah1h6o _4cvr1h6o _1p571ejb _gy1pxy5q _8fz6nklw _688gkb7n",
                            flipLayout && "_1f49kb7n",
                            numLogos === 7 && "_w9am12am _1bhm12am"
                        ]),
                        children: logos.map((logo, index)=>/*#__PURE__*/ (0, $loA2J.jsx)($edab1f6e8003d45e$var$IntegrationLogo, (0, $6iHNw._)((0, $7Knp0._)({}, logo), {
                                logoSize: logoSize
                            }), index))
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.ContentBlock), {
                        eyebrow: eyebrow,
                        title: title,
                        titleAs: titleAs,
                        text: body,
                        callToActionProps: linkLabel && linkHref ? {
                            link: {
                                text: linkLabel,
                                href: linkHref
                            }
                        } : undefined,
                        alignment: {
                            mobile: "center",
                            tablet: "start",
                            desktop: "start"
                        }
                    })
                ]
            })
        ]
    });
};
const $edab1f6e8003d45e$var$contentContainerStyles = null;
const $edab1f6e8003d45e$var$logosContainerStyles = null;
const $edab1f6e8003d45e$var$sevenLogosGridStyles = null;

});

parcelRegister("2Nqw3", function(module, exports) {

$parcel$export(module.exports, "Logos", function () { return $cfbf5b5ca75d407c$export$c847549a613b9060; });
/* logos.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $1UUq1 = parcelRequire("1UUq1");
const $cfbf5b5ca75d407c$export$c847549a613b9060 = ({ logos: logos })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1n261g80 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2mzuglyw _1bah1h6o _1p57oahv _gy1pxy5q _99s6xncg _1plrxncg _4cvr1h6o"
        ]),
        children: logos.map((logo, index)=>/*#__PURE__*/ (0, $loA2J.jsx)("li", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                    src: logo.src,
                    alt: logo.alt,
                    style: (0, $7Knp0._)({}, $cfbf5b5ca75d407c$var$logoStyles, logo.width ? {
                        width: `${logo.width}px`,
                        height: "auto"
                    } : {})
                })
            }, index))
    });
};
const $cfbf5b5ca75d407c$var$logosContainerStyle = null;
const $cfbf5b5ca75d407c$var$logoStyles = {
    height: "32px",
    width: "auto",
    maxWidth: "auto",
    filter: "grayscale(100%) brightness(66%)",
    ["-webkit-filter"]: "grayscale(100%) brightness(66%)"
};

});

parcelRegister("cJh4j", function(module, exports) {

$parcel$export(module.exports, "MobileApp", function () { return $998fa7af6915eee4$export$f81bbe9088ca57b0; });
/* mobile-app.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $1UUq1 = parcelRequire("1UUq1");
const $998fa7af6915eee4$export$f81bbe9088ca57b0 = ({ title: title, description: description, linkLabel: linkLabel, linkHref: linkHref, imageSrc: imageSrc, imageAlt: imageAlt = "", appleAppStoreUrl: appleAppStoreUrl, googlePlayStoreUrl: googlePlayStoreUrl })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1e0c11p5 _vchhusvi _zulp14hz _1bsb1osq _1dsl1tcg _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _bozgzwfg _y4tizwfg _qwmh1wqb _yu8o1wqb _1j8bwxkt _1vsw1vi7 _d2ik1wqb _exxm1wqb _10jxzqdx _1pfhxncg"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1yd3xy5q _40tuxncg _1mou1wug"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.ContentBlock), {
                        title: title,
                        titleAs: "h2",
                        text: description,
                        callToActionProps: linkLabel && linkHref ? {
                            link: {
                                text: linkLabel,
                                href: linkHref
                            }
                        } : undefined
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _zulppxbi _1pfhxy5q"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                href: appleAppStoreUrl,
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/3g0xj4162q6vj8iis1nr5pkh2scjm13a.png",
                                    alt: "Download on the Apple App Store"
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                href: googlePlayStoreUrl,
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/md1w60b88865q56fl84744t5u0heh751.png",
                                    alt: "Get it on the Google Play Store"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1reo15vq _18m915vq"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                    src: imageSrc,
                    alt: imageAlt,
                    className: (0, $esG4f.default)([
                        "_glte1osq _165t1pna _12rrk5xz _1vkhidpf _1x6l1osq _1bsb1osq _4t3ia91z _5ral1dfr _rsufq0ho"
                    ])
                })
            })
        ]
    });
};
const $998fa7af6915eee4$var$sectionStyles = null;
const $998fa7af6915eee4$var$leftSideContentStyles = null;
const $998fa7af6915eee4$var$appStoreLinksContainerStyles = null;
const $998fa7af6915eee4$var$imageContainerStyles = null;
const $998fa7af6915eee4$var$imageStyles = null;

});

parcelRegister("5STdK", function(module, exports) {

$parcel$export(module.exports, "SideNav", function () { return $3b6a124da0322dbd$export$1a35787d6353cf6a; });
/* side-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $ayjUl = parcelRequire("ayjUl");

var $2wO91 = parcelRequire("2wO91");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");
const $3b6a124da0322dbd$var$MobileExpandableNav = ({ title: title, children: children })=>{
    const [isExpanded, setIsExpanded] = (0, $iSvIT.useState)(false);
    const [buttonBottom, setButtonBottom] = (0, $iSvIT.useState)(0);
    const navRef = (0, $iSvIT.useRef)(null);
    const buttonRef = (0, $iSvIT.useRef)(null);
    const contentRef = (0, $iSvIT.useRef)(null);
    const handleToggle = ()=>{
        setIsExpanded(!isExpanded);
    }; // Calculate button position for nav positioning
    (0, $iSvIT.useEffect)(()=>{
        const updateButtonPosition = ()=>{
            if (buttonRef.current) {
                const rect = buttonRef.current.getBoundingClientRect();
                setButtonBottom(rect.bottom);
            }
        };
        updateButtonPosition();
        window.addEventListener("resize", updateButtonPosition);
        window.addEventListener("scroll", updateButtonPosition);
        return ()=>{
            window.removeEventListener("resize", updateButtonPosition);
            window.removeEventListener("scroll", updateButtonPosition);
        };
    }, []);
    // Prevent body scroll when nav is open
    (0, $iSvIT.useEffect)(()=>{
        if (isExpanded) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "unset";
        return ()=>{
            document.body.style.overflow = "unset";
        };
    }, [
        isExpanded
    ]);
    // Handle click outside to close nav
    (0, $iSvIT.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (isExpanded && navRef.current && !navRef.current.contains(event.target)) setIsExpanded(false);
        };
        if (isExpanded) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isExpanded
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        ref: navRef,
        className: (0, $esG4f.default)([
            "_kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("button", {
                ref: buttonRef,
                onClick: handleToggle,
                "aria-expanded": isExpanded,
                "aria-controls": "mobile-side-nav-content",
                className: (0, $esG4f.default)([
                    "_1bsb1osq _4t3i1wqb _bfhk150w _19itglyw _1yt41hnt _1e0c1txw _4cvr1h6o _zulpu2gc _80omtlke _v564mfn2 _kqswh2mm _1pbyibnn _irr3u4vp _s51sxy5q"
                ]),
                style: {
                    "--_8nj8hf": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light200")),
                    "--_1lmj1bv": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light300"))
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        className: (0, $esG4f.default)([
                            "_4t3i1ejb _1bsb1ejb _1e0c1txw _4cvr1h6o _1bah1h6o _syaz17la"
                        ]),
                        style: {
                            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                        },
                        children: isExpanded ? /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2wO91))), {
                            label: ""
                        }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ayjUl))), {
                            label: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        className: "eyebrow-md",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                ref: contentRef,
                id: "mobile-side-nav-content",
                className: (0, $esG4f.default)([
                    "_bfhkcd5j _1bsb1osq _18zr1wqb _v564vpel _1reo1wug _18m91wug _s51sxy5q",
                    isExpanded ? "_kqsw1n9t _152t1um1 _dk5didpf _u7coidpf _1bsbauwl _4t3iqi8f _c71lqi8f _tzy4kb7n _1pbyzo7u _1reo15vq _18m915vq _bfhkcd5j _1q51v47k _85i51wqb _18zr1wqb _s51sxy5q" : "_kqsw1n9t _c71lidpf _tzy4idpf _lcxvglyw _152tidpf _dk5didpf _1bsbauwl"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                    "--_ab93rs": (0, $43MIc.default)(buttonBottom, "px")
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_4t3i1osq _1reo1wug _18m91wug"
                    ]),
                    children: children
                })
            })
        ]
    });
};
const $3b6a124da0322dbd$export$6b43f262d1299a2e = ({ sideNavItems: sideNavItems })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
        className: (0, $esG4f.default)([
            "_qtt8glyw _18s8ze3t _1yt4ze3t _1reo1wug _18m91wug _1jc21nkh _1xey1k0a",
            "sidenav-menu"
        ]),
        style: {
            "--_1lmj1bv": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light300"))
        },
        children: sideNavItems.map((sideNavItem)=>{
            if (sideNavItem.type === "collection") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.SideNavCollection), {
                type: "collection",
                collectionName: sideNavItem.collectionName,
                sideNavItems: sideNavItem.sideNavItems,
                depth: 0
            }, sideNavItem.collectionName);
            if (sideNavItem.type === "link") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.SideNavLink), {
                type: "link",
                text: sideNavItem.text,
                href: sideNavItem.href,
                anchors: sideNavItem.anchors,
                depth: 0
            }, sideNavItem.text);
            return null;
        })
    });
};
const $3b6a124da0322dbd$export$1a35787d6353cf6a = ({ title: title, sideNavItems: sideNavItems })=>{
    const intl = (0, $f6qj2.default)();
    const navTitle = intl.formatMessage({
        id: "hub.sidenav.title",
        defaultMessage: `{hub} topics`
    }, {
        hub: title
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("nav", {
                id: "side-nav-desktop",
                "aria-label": intl.formatMessage({
                    id: "hub.sidenav.desktop.label",
                    defaultMessage: `{hub} Hub desktop navigation`
                }, {
                    hub: title
                }),
                className: (0, $esG4f.default)([
                    "_1mjbglyw",
                    "_kqsw1if8 _152tsxuq",
                    "_19ityzqy _2rkovwyg _1yt4v47k _85i51wqb _4t3i1ns9"
                ]),
                style: {
                    "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400")),
                    "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card"))
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _4cvr1h6o _1tke1wqb _1yt41dg4",
                            "eyebrow-md"
                        ]),
                        children: navTitle
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($3b6a124da0322dbd$export$6b43f262d1299a2e, {
                        sideNavItems: sideNavItems
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("nav", {
                id: "side-nav-tablet-mobile",
                "aria-label": intl.formatMessage({
                    id: "hub.sidenav.mobile.label",
                    defaultMessage: `{hub} Hub mobile navigation`
                }, {
                    hub: title
                }),
                className: (0, $esG4f.default)([
                    "_dm25glyw",
                    "_kqsw1n9t _1e02idpf _1pbyegat _1bsbauwl"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)($3b6a124da0322dbd$var$MobileExpandableNav, {
                    title: navTitle,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)($3b6a124da0322dbd$export$6b43f262d1299a2e, {
                        sideNavItems: sideNavItems
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_dm25glyw",
                    "_4t3i1wqb"
                ])
            })
        ]
    });
};
const $3b6a124da0322dbd$var$desktopCss = null;
const $3b6a124da0322dbd$var$tabletMobileCss = null;
const $3b6a124da0322dbd$var$stickyCss = null;
const $3b6a124da0322dbd$var$fixedCss = null;
const $3b6a124da0322dbd$var$listCss = null;
const $3b6a124da0322dbd$var$containerCss = null;
const $3b6a124da0322dbd$var$desktopTitleCss = null;
const $3b6a124da0322dbd$var$mobileIconCss = null;
const $3b6a124da0322dbd$var$mobileExpandableButtonCss = null;
const $3b6a124da0322dbd$var$mobileNavContentCss = null;
const $3b6a124da0322dbd$var$mobileNavContentCollapsedCss = null;
const $3b6a124da0322dbd$var$mobileInnerContentCss = null;

});
parcelRegister("ayjUl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e570c2c471e9f2c44e5e57e4d5245eb9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7aec85a235a3439c$var$_react = $7aec85a235a3439c$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $7aec85a235a3439c$var$_baseNew = $7aec85a235a3439c$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $7aec85a235a3439c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7aec85a235a3439c$var$AddIcon = (props)=>/*#__PURE__*/ $7aec85a235a3439c$var$_react.default.createElement($7aec85a235a3439c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 8.75V15h1.5V8.75H15v-1.5H8.75V1h-1.5v6.25H1v1.5z" clip-rule="evenodd"/>`
    }, props));
$7aec85a235a3439c$var$AddIcon.displayName = "AddIcon";
var $7aec85a235a3439c$var$_default = module.exports.default = $7aec85a235a3439c$var$AddIcon;

});

parcelRegister("2wO91", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e2df2c0b677df1945f42cd8e58b7f64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1d75779a6f475134$var$_react = $1d75779a6f475134$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $1d75779a6f475134$var$_baseNew = $1d75779a6f475134$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $1d75779a6f475134$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Minus".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: horizontal rule in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1d75779a6f475134$var$MinusIcon = (props)=>/*#__PURE__*/ $1d75779a6f475134$var$_react.default.createElement($1d75779a6f475134$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 8.75H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$1d75779a6f475134$var$MinusIcon.displayName = "MinusIcon";
var $1d75779a6f475134$var$_default = module.exports.default = $1d75779a6f475134$var$MinusIcon;

});


parcelRegister("2p5f0", function(module, exports) {

$parcel$export(module.exports, "Stats", function () { return $4cd1e849e8192d3a$export$3cdec2bba15e3523; });
/* stats.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $eDoPe = parcelRequire("eDoPe");

var $fxdfZ = parcelRequire("fxdfZ");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");
const $4cd1e849e8192d3a$var$earthStyles = null;
const $4cd1e849e8192d3a$export$cc52242338d2406f = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_kqswstnw _1e02idpf _152txard _bna71wug _rtys1osq _t9ec1u9r _1h1t1ekt _tnru1wug _1rfm12eq _xaejlc6t _1eg616tw _95u51a2f"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/435e558616x6e3c2jvth65jiq2vusf20.webp",
                alt: "",
                width: 700,
                height: 700
            }
        })
    });
};
const $4cd1e849e8192d3a$var$easeOutQuad = (t)=>t * (2 - t);
const $4cd1e849e8192d3a$var$frameDuration = 1000 / 60;
const $4cd1e849e8192d3a$var$AnimateCount = ({ children: children = "0", duration: duration = 2000 })=>{
    const countTo = parseInt(children, 10);
    const [count, setCount] = (0, $iSvIT.useState)(0);
    (0, $iSvIT.useEffect)(()=>{
        let frame = 0;
        const totalFrames = Math.round(duration / $4cd1e849e8192d3a$var$frameDuration);
        const counter = setInterval(()=>{
            frame++;
            const progress = $4cd1e849e8192d3a$var$easeOutQuad(frame / totalFrames);
            setCount(countTo * progress);
            if (frame === totalFrames) clearInterval(counter);
        }, $4cd1e849e8192d3a$var$frameDuration);
        return ()=>clearInterval(counter);
    }, [
        countTo,
        duration
    ]);
    return Math.floor(count).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
const $4cd1e849e8192d3a$export$3cdec2bba15e3523 = (statsProps)=>{
    var _statsProps_bigStat_statSymbol, _statsProps_bigStat_statSymbol1;
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $eDoPe.useInView)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        ref: scrollRef,
        className: (0, $esG4f.default)([
            "_p12f1git _19pkidpf _2hwx1wug _otyridpf _18u01wug _kqswh2mm _1pbykb7n _ca0qymf6 _u5f3idpf _n3td53f4 _19bvidpf _1reo15vq _18m915vq _11q71rga _mkrz13pj _1vth1g58 _1kmxidpf _1ggmidpf _1ykzidpf _1maeidpf _srwz1ylp"
        ]),
        style: {
            "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1q51gktf _85i5gktf _1gde1bp4",
                    "wrapper"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1q511ul9 _p12f1osq _1e0c1txw _4cvr1y6m _zulp1ylp _kqswh2mm _1t19idpf _p7vbidpf _1rhg1w8u _19wggktf _1gde1bp4 _1u2q1wqb",
                            "text-wrapper"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_16jlkb7n _1o9zkb7n _i0dl1ssb _1fe7kb7n _12ihkb7n _1a1xf1ug _1rfm1osq",
                                    "fifty"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                        className: (0, $esG4f.default)([
                                            "_1wyb8pqr _vwz4cjiy _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                        ]),
                                        children: statsProps.headerText
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                                        className: (0, $esG4f.default)([
                                            "_ect4qlpn _vwz4zg3v _k48p53lb _19pk19bv _2hwxidpf _otyrftgi _18u0idpf _kqswh2mm _syaz17la",
                                            "_1wyb1qf2 _g4miqd8k _1lzo1bc9",
                                            "big-stat"
                                        ]),
                                        style: {
                                            "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display")),
                                            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
                                                className: (0, $esG4f.default)([
                                                    "_syaz1bjw",
                                                    "big-stat"
                                                ]),
                                                style: {
                                                    "--_1shjtka": (0, $43MIc.default)(statsProps.bigStat.statColor ? statsProps.bigStat.statColor : (0, $5ohHq.wacToken)("color.primary.black"))
                                                },
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $fxdfZ.default), {
                                                        fallback: null,
                                                        children: sectionIsVisible ? /*#__PURE__*/ (0, $loA2J.jsx)($4cd1e849e8192d3a$var$AnimateCount, {
                                                            children: statsProps.bigStat.stat
                                                        }) : statsProps.bigStat.stat
                                                    })
                                                ]
                                            }),
                                            statsProps.bigStat.statSymbol && /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                                className: (0, $esG4f.default)([
                                                    "_syaz1y4s"
                                                ]),
                                                style: {
                                                    "--_1bnfnau": (0, $43MIc.default)(((_statsProps_bigStat_statSymbol = statsProps.bigStat.statSymbol) === null || _statsProps_bigStat_statSymbol === void 0 ? void 0 : _statsProps_bigStat_statSymbol.symbolCharacterColor) ? statsProps.bigStat.statSymbol.symbolCharacterColor : (0, $5ohHq.wacToken)("color.primary.black"))
                                                },
                                                children: (_statsProps_bigStat_statSymbol1 = statsProps.bigStat.statSymbol) === null || _statsProps_bigStat_statSymbol1 === void 0 ? void 0 : _statsProps_bigStat_statSymbol1.symbolCharacter
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                        className: (0, $esG4f.default)([
                                            "_1wyb1j6v _k48pl8b6 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                        ]),
                                        children: statsProps.bigStat.statText
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_16jlkb7n _1o9zkb7n _i0dl1r5k _1e0c1txw _zulpgktf _2lx21bp4 _y4ti1ylp _1fe7kb7n _12ihkb7n _1a1xf1ug _chtuidpf",
                                    "thirty"
                                ]),
                                children: statsProps.littleStats.map((statObj, index)=>{
                                    var _statObj_statSymbol, _statObj_statSymbol1;
                                    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                        className: (0, $esG4f.default)([
                                            "_kqswh2mm _bozggktf",
                                            "stat-wrapper"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_kqswstnw _4t3i1osq _11q71hlo _1bsbyh40 _1e02idpf"
                                                ]),
                                                style: {
                                                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                className: (0, $esG4f.default)([
                                                    "_ect4qlpn _vwz4zg3v _k48p53lb _19pk19bv _2hwxidpf _otyrftgi _18u0idpf _kqswh2mm _syaz17la",
                                                    "_1wybxxch",
                                                    "little-stat"
                                                ]),
                                                style: {
                                                    "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display")),
                                                    "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                                                },
                                                children: /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
                                                    className: (0, $esG4f.default)([
                                                        "_syazoodi"
                                                    ]),
                                                    style: {
                                                        "--_11wxpl2": (0, $43MIc.default)(statObj.statColor ? statObj.statColor : (0, $5ohHq.wacToken)("color.primary.black"))
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $fxdfZ.default), {
                                                            fallback: null,
                                                            children: sectionIsVisible ? /*#__PURE__*/ (0, $loA2J.jsx)($4cd1e849e8192d3a$var$AnimateCount, {
                                                                children: statObj.stat
                                                            }) : statObj.stat
                                                        }),
                                                        statObj.statSymbol && /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                                            className: (0, $esG4f.default)([
                                                                "_syaz16k1"
                                                            ]),
                                                            style: {
                                                                "--_1nxvphm": (0, $43MIc.default)(((_statObj_statSymbol = statObj.statSymbol) === null || _statObj_statSymbol === void 0 ? void 0 : _statObj_statSymbol.symbolCharacterColor) ? statObj.statSymbol.symbolCharacterColor : (0, $5ohHq.wacToken)("color.primary.black"))
                                                            },
                                                            children: (_statObj_statSymbol1 = statObj.statSymbol) === null || _statObj_statSymbol1 === void 0 ? void 0 : _statObj_statSymbol1.symbolCharacter
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                className: (0, $esG4f.default)([
                                                    "_1wyb1j6v _k48pl8b6 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                                ]),
                                                children: statObj.statText
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1h1tgbua _kqswh2mm _rjxpidpf _u7coidpf _152tidpf _4t3i1osq _1e0c1txw _1bah1h6o _mmgkgktf _1rfm1osq _tnru68cl _srwzidpf _476d1ylp _1t06idpf _1jc21gwv _10jx1gwv",
                            "earth-contents"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)($4cd1e849e8192d3a$export$cc52242338d2406f, {}),
                            /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                                className: (0, $esG4f.default)([
                                    "_kqswstnw _152tidpf _1o2w1n0t _rjxp3ll0 _p5ce1x96 _1l7d176h _xaej15qf _1rfm68cl _tnru1wug",
                                    "blob"
                                ]),
                                width: "102",
                                height: "95",
                                "aria-hidden": "true",
                                viewBox: "0 0 102 95",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M97.6377 58.2134C98.2297 54.8868 98.5329 51.356 98.5329 47.6063C98.5329 43.8566 98.2152 40.2236 97.6233 36.8533C94.057 16.8063 80.2829 4.44834 60.9645 1.28226C57.6726 0.742421 54.2074 0.46521 50.6123 0.46521C47.0172 0.46521 43.2632 0.771614 39.8414 1.34063C20.5085 4.60885 6.74887 16.923 3.18262 36.8533C2.57621 40.2236 2.27301 43.7982 2.27301 47.6063C2.27301 51.4143 2.57621 54.8868 3.16818 58.2134C6.70555 78.1144 20.4797 90.4578 39.8414 93.726C43.2632 94.3096 46.8728 94.6014 50.6123 94.6014C54.3518 94.6014 57.6726 94.3242 60.9645 93.7844C80.3118 90.6037 94.1148 78.2312 97.6521 58.2134H97.6377Z",
                                        fill: "#FCA700"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                                className: (0, $esG4f.default)([
                                    "_1bsbutna _4t3i1wug _kqswstnw _1e021nh5 _u7co1228 _sugaglyw",
                                    "lightning"
                                ]),
                                width: "131",
                                height: "139",
                                "aria-hidden": "true",
                                viewBox: "0 0 131 139",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M20.4793 61.2896C11.5228 63.9778 10.6462 63.8696 8.14861 74.6224C5.48565 77.7767 3.98043 82.2375 2.50009 87.7471C1.52422 89.9276 8.05758 89.112 4.36913 89.8361C6.75918 90.66 13.6813 90.2023 14.4338 91.2343C10.9604 99.0243 8.42147 107.638 6.13066 115.911C6.18028 130.151 27.1036 98.5582 29.5102 96.5941C30.7176 93.1152 44.2806 78.484 38.1442 78.1761C29.196 76.6947 23.4234 81.4636 30.1387 69.8369C30.2793 69.3875 33.3061 62.3049 32.6197 60.1909C28.0133 62.1883 27.0788 70.1864 24.2752 74.5474C19.5778 80.881 28.6253 81.9463 32.6114 81.3554C32.5618 82.2875 36.1345 80.7562 35.2909 82.7037C30.1718 90.2606 12.9866 112.723 13.028 112.765C11.7296 115.611 9.81084 116.752 9.33117 115.861C9.04172 115.328 18.2546 92.6159 19.5117 89.6947C20.5289 86.1243 14.2436 86.9482 14.2436 86.9482C14.2436 86.9482 14.897 87.2727 16.7578 87.3226C14.8143 87.8969 9.87707 87.1396 6.51115 86.8733C7.08179 81.7382 13.7061 65.3676 13.7061 65.3676C13.7061 65.3676 27.7817 64.2191 31.3378 59.9662C28.7245 59.7415 24.3001 61.0649 20.471 61.2979L20.4793 61.2896Z",
                                        fill: "#101214"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M128.71 53.5661L129.636 51.8599C129.934 51.294 130.314 50.7031 130.413 50.1954C130.537 49.6877 130.521 49.2633 130.488 48.9138C130.48 48.8139 130.488 48.7556 130.438 48.6391C130.397 48.5225 130.306 48.3894 130.248 48.3395C130.116 48.2313 129.983 48.1147 129.818 47.9982C129.487 47.7735 129.065 47.5322 128.47 47.424C127.858 47.3408 127.205 47.2908 126.576 47.2159C123.392 46.8913 120.216 46.5667 117.082 46.2505C114.138 45.9425 111.227 45.6346 108.341 45.335C105.76 45.052 103.205 44.7774 100.691 44.5027C100.492 44.4528 100.178 44.5193 100.137 44.253C100.153 44.0283 100.31 43.8369 100.393 43.6455C100.972 42.3971 101.543 41.1571 102.113 39.9336C103.395 37.1955 104.644 34.5239 105.86 31.9189C108.316 26.7256 110.689 21.8236 112.972 17.2878L112.699 17.5541C112.889 17.2295 113.303 16.1393 113.576 15.9479C113.923 14.9075 114.436 13.4843 115.039 11.9113C115.345 11.129 115.66 10.3051 115.982 9.47285L116.47 8.22446C116.76 7.53368 117.041 6.85116 117.322 6.17702C117.653 5.36141 117.702 4.6707 117.653 4.06315C117.587 3.43063 117.347 2.78144 116.958 2.27376C116.189 1.21679 114.948 0.800607 114.088 0.867188C113.063 1.14183 112.219 1.35825 111.632 1.51638C111.326 1.63289 111.086 1.7245 110.913 1.78276C110.789 1.82437 110.731 1.8493 110.731 1.8493C106.794 3.33905 102.626 4.49591 98.4578 5.61114C98.4578 5.61114 97.0768 5.87744 94.8769 6.31021C93.7687 6.5266 92.462 6.78464 91.0065 7.07593C90.2787 7.22574 89.5096 7.39216 88.7157 7.55861C88.3187 7.64184 87.9052 7.74169 87.4834 7.84988C87.0865 7.94975 86.6896 8.05795 86.2843 8.16614C83.0673 8.99008 79.4202 9.78077 76.1535 11.1124C74.5243 11.7699 73.0026 12.5771 71.729 13.4843C70.4472 14.3915 69.4216 15.4152 68.6939 16.3473C66.6181 18.4696 65.0798 21.008 63.8228 23.613C62.5575 26.2263 61.5733 28.9228 60.5974 31.5943C59.6464 34.2826 58.6292 36.8626 57.5458 39.5008L54.3536 47.3907C54.3536 47.3907 49.4163 60.7236 48.4156 64.9348C48.0931 66.2831 47.8864 67.4066 47.7871 68.2472C48.1841 68.2139 48.7382 68.1889 49.4328 68.1806C50.6899 65.9085 52.6582 61.3311 55.4452 53.7408C55.5527 53.5993 55.8008 53.1084 55.8918 53.0668C57.0744 49.6378 58.3315 46.2838 59.6465 42.9547C60.3163 41.2985 60.9862 39.6424 61.656 37.9862C62.3507 36.2967 62.9958 34.5821 63.6243 32.9176C64.8896 29.5886 66.1467 26.3178 67.7842 23.4132C68.6029 21.9651 69.5126 20.6085 70.5546 19.4267C71.5967 18.2365 72.7297 17.2711 74.086 16.4389C73.8213 16.3224 74.086 15.9145 74.4995 15.8479L74.5243 16.1808C76.3189 14.999 78.2789 14.2666 80.181 13.6924C82.0914 13.1181 83.9853 12.7103 85.8874 12.2609L87.3181 11.9113L88.7157 11.5452C89.6254 11.3205 90.5352 11.0957 91.4697 10.871C93.3801 10.3966 95.3814 9.84733 97.5233 9.11493C97.5068 9.12326 96.6053 9.71416 96.5888 9.7308C100.037 8.97344 103.627 8.15785 107.398 7.15081C108.341 6.88448 109.292 6.62649 110.259 6.32688C110.739 6.18539 111.227 6.03554 111.715 5.86909L112.145 5.72767L112.236 5.69435C112.352 5.64441 112.509 5.57783 112.616 5.69435C112.732 5.80254 112.658 5.96065 112.6 6.08549C109.813 12.3025 106.877 18.869 103.883 25.5521C102.32 29.0476 100.74 32.5681 99.1691 36.0969C98.3834 37.8613 97.5978 39.6257 96.8121 41.3818L95.8527 43.5206C95.6625 43.9284 95.4971 44.3446 95.431 44.7275C95.3648 45.1103 95.3649 45.4515 95.3897 45.7595C95.4145 46.3587 95.828 47.1993 96.3408 47.6321C96.5806 47.8484 96.837 47.9983 97.1595 48.1647C97.4903 48.3145 97.879 48.4394 98.3173 48.4893C105.239 49.1801 111.988 49.8542 118.521 50.5117C120.068 50.6615 121.598 50.8113 123.119 50.9528L124.252 51.061L124.74 51.1026H124.839L125.269 51.1275C125.327 51.1442 125.451 51.0943 125.46 51.1858L125.377 51.3689L125.195 51.76C124.906 52.3177 124.608 52.867 124.318 53.4246C123.979 54.0654 123.648 54.7063 123.293 55.3305L123.417 55.2056V55.2888C123.649 54.9726 123.963 54.5066 124.327 53.9073C124.674 53.3497 125.087 52.6838 125.534 51.9515C125.724 51.6851 125.956 51.3606 126.212 50.9778C126.262 50.8779 126.378 50.7947 126.378 50.6782C126.328 50.5866 126.204 50.6199 126.121 50.5783C125.915 50.5367 125.716 50.4951 125.517 50.4618C125.294 50.4202 125.071 50.3785 124.864 50.3369C124.393 50.2703 123.938 50.2038 123.5 50.1455C122.59 50.0207 121.763 49.9041 121.052 49.8126C119.638 49.6212 118.72 49.4963 118.72 49.4963C120.109 49.4547 121.523 49.463 122.946 49.5046C123.64 49.5379 124.343 49.5629 125.046 49.5962C125.592 49.6212 126.163 49.6544 126.742 49.6961L127.618 49.7709C127.693 49.7792 127.767 49.771 127.833 49.7959C127.899 49.8209 127.949 49.8958 127.932 49.9707C127.874 50.1038 127.8 50.2287 127.734 50.3536C127.453 50.8613 127.172 51.3772 126.882 51.8932C126.551 52.4758 126.212 53.0667 125.873 53.6493C125.501 54.2985 125.129 54.9476 124.732 55.5884C123.136 58.1352 121.564 60.7152 119.886 63.212C119.067 64.477 118.248 65.7338 117.438 66.9822C116.611 68.2222 115.8 69.4623 115.023 70.7107L114.742 70.4277C117.512 66.1749 119.629 62.1717 120.44 60.5571C115.593 68.2639 108.068 79.6908 99.8224 90.4602C95.7453 95.8783 91.4531 101.105 87.5 105.816C85.5069 108.154 83.6213 110.393 81.8185 112.399C80.9253 113.414 80.0735 114.388 79.263 115.312C78.4443 116.227 77.6669 117.093 76.9391 117.9C77.2037 117.842 78.1548 116.718 79.2382 115.578C80.3133 114.429 81.4959 113.223 82.3229 113.056C81.5786 113.888 80.8261 114.721 80.0818 115.545C79.3292 116.36 78.5684 117.176 77.8241 117.983C77.0715 118.79 76.3271 119.589 75.5911 120.38C74.8468 121.162 74.086 121.92 73.3416 122.661C72.8951 122.211 74.7641 120.646 75.0205 120.222C74.3093 120.788 72.1094 122.952 68.7187 126.114C67.0151 127.687 65.055 129.552 62.789 131.541C62.5161 131.782 62.2432 132.024 61.9703 132.273L61.7718 132.44C61.6312 132.531 61.532 132.681 61.3666 132.714C61.2012 132.739 61.0275 132.631 60.9614 132.465C60.8869 132.29 60.9944 132.115 61.0358 131.948C61.6395 129.901 62.268 127.754 62.9131 125.54C63.6822 122.96 64.4927 120.305 65.3446 117.6C67.0482 112.191 68.9006 106.573 70.8606 100.963C72.8124 95.3539 74.8716 89.7445 76.9474 84.3348C77.9811 81.63 79.0232 78.975 80.0569 76.395L80.4374 75.4296L80.6276 74.9469C80.6607 74.8636 80.6938 74.8054 80.7186 74.6889L80.8013 74.3227C81.0246 73.3406 81.2479 72.3668 81.4712 71.4014C81.5787 70.9187 81.6944 70.436 81.8019 69.9616L81.9674 69.2459L82.0501 68.8881C82.0583 68.8298 82.0914 68.7632 82.0832 68.7216C82.0584 68.6633 82.0087 68.6633 81.9591 68.6384C81.2313 68.3471 80.5036 68.0557 79.7841 67.7644C77.7 67.8477 75.6656 67.9226 73.6807 67.9975C72.2418 68.0391 70.8359 68.0724 69.4796 68.1057C66.767 68.1639 64.2198 68.1889 61.8959 68.1889C57.2398 68.1723 53.4522 68.164 50.8719 68.1557C50.3426 68.1557 49.8794 68.1557 49.4494 68.1557C49.2757 68.4719 49.1186 68.7382 48.9698 68.9629C49.8216 69.1128 50.9545 69.2792 52.4266 69.4789L51.5086 69.7619C56.082 70.0698 60.2584 70.253 64.501 70.4194C66.6181 70.4943 68.7517 70.5692 70.9516 70.6525C72.0515 70.6858 73.168 70.7274 74.3093 70.769C74.8799 70.7856 75.4588 70.8106 76.0377 70.8272C76.4512 70.8522 76.8647 70.8771 77.2865 70.9021C77.394 70.8938 77.4932 70.8855 77.5759 70.8772C78.2706 70.8189 78.3451 70.8355 78.6759 70.5276C79.0067 70.461 79.6517 70.3445 79.7261 70.203C79.8502 70.1031 79.9991 70.0116 80.1645 69.9367C80.2141 69.9201 80.3299 69.8785 80.3299 69.9367C80.3299 69.97 80.3299 70.0199 80.3216 70.0781C80.2803 70.3029 80.1645 70.6857 80.0074 71.1268C79.6931 72.0173 79.2217 73.0743 78.9819 73.7235C78.1549 72.5416 75.2273 79.3828 72.5809 87.1395C69.8931 94.8712 67.5443 103.469 66.8331 105.433C65.452 105.832 64.2198 113.214 63.0289 115.461C63.0372 115.278 63.1116 114.13 63.1281 113.98C62.7891 114.463 61.9538 117.026 60.9945 120.48C60.5148 122.203 59.9937 124.15 59.4727 126.156C58.9352 128.295 58.3811 130.5 57.8518 132.606C57.703 133.255 57.6368 133.821 57.6202 134.346C57.612 134.878 57.8105 135.427 58.1744 135.844C58.8773 136.709 60.1427 136.925 60.9779 136.501C61.7553 136.06 62.4582 135.394 63.0867 134.795C63.6491 134.271 64.1453 133.813 64.5588 133.438C66.0971 132.048 66.4692 131.907 64.7408 133.987C71.4147 128.528 78.742 121.678 86.1437 113.705C93.5702 105.757 100.972 96.6024 108.035 86.79C115.081 76.961 121.688 66.3996 127.61 55.6551L128.743 53.5661H128.71Z",
                                        fill: "#101214"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
const $4cd1e849e8192d3a$var$wrapperStyle = null;
const $4cd1e849e8192d3a$var$earthContents = null;
const $4cd1e849e8192d3a$var$blobStyles = null;
const $4cd1e849e8192d3a$var$lightningStyles = null;
const $4cd1e849e8192d3a$var$TextWrapperStyles = null;
const $4cd1e849e8192d3a$var$fiftyStyles = null;
const $4cd1e849e8192d3a$var$h2Styles = null;
const $4cd1e849e8192d3a$var$statStyles = null;
const $4cd1e849e8192d3a$var$bigStatStyles = null;
const $4cd1e849e8192d3a$var$littleStatStyles = null;
const $4cd1e849e8192d3a$var$statTextStyles = null;
const $4cd1e849e8192d3a$var$thirtyStyles = null;
const $4cd1e849e8192d3a$var$statWrapperStyles = null;
const $4cd1e849e8192d3a$var$dividerStyles = null;
const $4cd1e849e8192d3a$var$statsStyles = null;

});

parcelRegister("62VZK", function(module, exports) {

$parcel$export(module.exports, "useTabsContext", function () { return (parcelRequire("cPhXv")).useTabsContext; });
$parcel$export(module.exports, "Tabs", function () { return (parcelRequire("cPhXv")).Tabs; });
$parcel$export(module.exports, "DraggableTabList", function () { return (parcelRequire("gq8af")).DraggableTabList; });
$parcel$export(module.exports, "DraggableTab", function () { return (parcelRequire("6YaIp")).DraggableTab; });
$parcel$export(module.exports, "TabPanel", function () { return (parcelRequire("bN8aD")).TabPanel; });
$parcel$export(module.exports, "TabsSection", function () { return (parcelRequire("7CBQh")).TabsSection; });
$parcel$export(module.exports, "mapChild", function () { return (parcelRequire("kWavG")).mapChild; });

var $cPhXv = parcelRequire("cPhXv");

var $gq8af = parcelRequire("gq8af");

var $6YaIp = parcelRequire("6YaIp");

var $bN8aD = parcelRequire("bN8aD");

var $7CBQh = parcelRequire("7CBQh");

var $kWavG = parcelRequire("kWavG");

});
parcelRegister("cPhXv", function(module, exports) {

$parcel$export(module.exports, "useTabsContext", function () { return $5601ed8c8774e035$export$5c3d36c3adf0ba92; });
$parcel$export(module.exports, "Tabs", function () { return $5601ed8c8774e035$export$b2539bed5023c21c; });
/* tabs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $eDoPe = parcelRequire("eDoPe");

var $4xseM = parcelRequire("4xseM");

var $kWavG = parcelRequire("kWavG");
const $5601ed8c8774e035$var$TabsContext = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
const $5601ed8c8774e035$export$5c3d36c3adf0ba92 = ()=>{
    const context = (0, $iSvIT.useContext)($5601ed8c8774e035$var$TabsContext);
    if (!context) throw new Error("useTabsContext must be used within Tabs");
    return context;
};
let $5601ed8c8774e035$var$nextId = 0;
const $5601ed8c8774e035$export$b2539bed5023c21c = ({ id: id, initialTab: initialTab, loop: loop = true, children: children, useInViewOptionsContainer: useInViewOptionsContainer })=>{
    const [currentTab, setCurrentTab] = (0, $iSvIT.useState)(initialTab !== null && initialTab !== void 0 ? initialTab : 0);
    const [userSelected, setUserSelected] = (0, $iSvIT.useState)(false);
    const [focus, setFocus] = (0, $iSvIT.useState)(false);
    const tabIds = (0, $iSvIT.useRef)([]);
    const contextId = (0, $iSvIT.useRef)(`:tabs:${id ? id : $5601ed8c8774e035$var$nextId++}:`);
    const DEFAULT_IN_VIEW_THRESHOLD = 0.3;
    const { ref: containerScrollRef, inView: tabsContainerIsVisible } = (0, $eDoPe.useInView)((0, $7Knp0._)({
        threshold: DEFAULT_IN_VIEW_THRESHOLD
    }, useInViewOptionsContainer));
    const { ref: tabListScrollRef, inView: tabListIsVisible } = (0, $eDoPe.useInView)({
        threshold: DEFAULT_IN_VIEW_THRESHOLD
    });
    function getTabsCount() {
        let count = 0;
        (0, $kWavG.deepForEach)(children, (child)=>{
            if ((0, $kWavG.isTab)(child)) count++;
        });
        return count;
    }
    function getChildren() {
        let panelIndex = 0;
        tabIds.current = tabIds.current || [];
        let diff = tabIds.current.length - getTabsCount(); // Add ids if new tabs have been added
        // Don't bother removing ids, just keep them in case they are added again
        // This is more efficient, and keeps the uuid counter under control
        while(diff++ < 0)tabIds.current.push(`${contextId.current}${tabIds.current.length}`);
         // Map children to dynamically setup refs
        return (0, $kWavG.deepMap)(children, (child)=>{
            var _window_document_activeElement;
            let result = child; // Check if the window is available
            const windowAvailable = !!window && !!window.document && !!window.document.activeElement; // Get the active element id
            const activeElementId = windowAvailable ? (_window_document_activeElement = window.document.activeElement) === null || _window_document_activeElement === void 0 ? void 0 : _window_document_activeElement.id : null; // Clone TabList and Tab components to have refs
            if ((0, $kWavG.isTabList)(child)) {
                let listIndex = 0; // Figure out if the current focus in the DOM is set on a Tab
                // If it is we should keep the focus on the next selected tab
                let wasTabFocus = false;
                if (windowAvailable && activeElementId) // Check if the active element is a tab
                wasTabFocus = (0, $iSvIT.Children).toArray(child.props.children).filter((0, $kWavG.isTab)).some((_, i)=>{
                    return activeElementId === `tab${tabIds.current[i]}`;
                });
                result = /*#__PURE__*/ (0, $iSvIT.cloneElement)(child, {
                    children: (0, $kWavG.deepMap)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    child.props.children, (tab)=>{
                        const selected = currentTab === listIndex;
                        const props = {
                            id: tabIds.current[listIndex],
                            tabIndex: listIndex,
                            focus: selected && (focus || wasTabFocus)
                        };
                        listIndex++;
                        return /*#__PURE__*/ (0, $iSvIT.cloneElement)(tab, props);
                    })
                });
            } else if ((0, $kWavG.isTabPanel)(child)) {
                // Preserve existing props (like hideTabPanelRole) when cloning
                const existingProps = child.props || {};
                const props = (0, $6iHNw._)((0, $7Knp0._)({}, existingProps), {
                    id: tabIds.current[panelIndex],
                    panelIndex: panelIndex
                });
                panelIndex++;
                result = /*#__PURE__*/ (0, $iSvIT.cloneElement)(child, props);
            }
            return result;
        });
    }
    const goToTab = (tabIndex)=>{
        if (tabIndex === undefined) return;
        setCurrentTab(tabIndex);
    };
    const isCurrentTab = (tabIndex)=>{
        return tabIndex === currentTab;
    };
    const goToNextTab = (0, $iSvIT.useCallback)(()=>{
        if (currentTab + 1 < tabIds.current.length) goToTab(currentTab + 1);
        else if (loop) goToTab(0);
    }, [
        loop,
        currentTab
    ]);
    const goToPrevTab = (0, $iSvIT.useCallback)(()=>{
        if (currentTab - 1 >= 0) goToTab(currentTab - 1);
        else if (loop) goToTab(tabIds.current.length - 1);
    }, [
        loop,
        currentTab
    ]);
    const goToFirstTab = ()=>{
        goToTab(0);
    };
    const goToLastTab = ()=>{
        goToTab(tabIds.current.length - 1);
    };
    const onKeyDown = (e)=>{
        if (e.code === "ArrowLeft" || e.code === "ArrowUp") goToPrevTab();
        else if (e.code === "ArrowRight" || e.code === "ArrowDown") goToNextTab();
        else if (e.code === "End") // Select last tab (End key)
        goToFirstTab();
        else if (e.code === "Home") // Select first tab (Home key)
        goToLastTab();
        else return;
        setUserSelected(true);
        setFocus(true); // This prevents scrollbars from moving around
        e.preventDefault();
    }; // Reset the userSelected state when the section is visible again
    (0, $iSvIT.useEffect)(()=>{
        if (tabsContainerIsVisible) setUserSelected(false);
    }, [
        tabsContainerIsVisible
    ]); // Reinitialize analytics when the tab changes
    // this is needed because the content wasn't rendered before
    (0, $iSvIT.useEffect)(()=>{
        (0, $4xseM.Initializer).autoTrack();
    }, [
        currentTab
    ]);
    const containerStyles = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)($5601ed8c8774e035$var$TabsContext.Provider, {
        value: {
            currentTab: currentTab,
            userSelected: userSelected,
            goToTab: goToTab,
            isCurrentTab: isCurrentTab,
            goToNextTab: goToNextTab,
            goToPrevTab: goToPrevTab,
            goToFirstTab: goToFirstTab,
            goToLastTab: goToLastTab,
            onKeyDown: onKeyDown,
            tabsContainerIsVisible: tabsContainerIsVisible,
            tabListIsVisible: tabListIsVisible,
            tabListScrollRef: tabListScrollRef
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            ref: containerScrollRef,
            className: (0, $esG4f.default)([
                "_1e0c1txw _2lx21bp4 _zulp1jfw _1reo15vq _18m915vq"
            ]),
            children: getChildren()
        })
    });
};

});
parcelRegister("kWavG", function(module, exports) {

$parcel$export(module.exports, "isTab", function () { return $9ba823149c88c072$export$bdc9792d96913679; });
$parcel$export(module.exports, "isTabList", function () { return $9ba823149c88c072$export$9c326233b9ae5588; });
$parcel$export(module.exports, "isTabPanel", function () { return $9ba823149c88c072$export$9e12445c79db89b; });
$parcel$export(module.exports, "mapChild", function () { return $9ba823149c88c072$export$886f34b49305b07b; });
$parcel$export(module.exports, "deepMap", function () { return $9ba823149c88c072$export$ce7eaaed37329a1b; });
$parcel$export(module.exports, "deepForEach", function () { return $9ba823149c88c072$export$519ada94592b97fc; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $iSvIT = parcelRequire("iSvIT");
function $9ba823149c88c072$var$makeTypeChecker(tabsRole) {
    return (element)=>!!element.type && element.type.tabsRole === tabsRole;
}
const $9ba823149c88c072$export$bdc9792d96913679 = $9ba823149c88c072$var$makeTypeChecker("Tab");
const $9ba823149c88c072$export$9c326233b9ae5588 = $9ba823149c88c072$var$makeTypeChecker("TabList");
const $9ba823149c88c072$export$9e12445c79db89b = $9ba823149c88c072$var$makeTypeChecker("TabPanel");
const $9ba823149c88c072$export$dbaa4172856e20ab = (element)=>!!element.type && typeof element.type === "function";
function $9ba823149c88c072$var$isTabChild(child) {
    return $9ba823149c88c072$export$bdc9792d96913679(child) || $9ba823149c88c072$export$9c326233b9ae5588(child) || $9ba823149c88c072$export$9e12445c79db89b(child);
}
function $9ba823149c88c072$export$886f34b49305b07b(child, additionalProps) {
    if (child === null) return null;
    // Only pass additionalProps to functional components
    // React.cloneElement will throw an error if you pass additionalProps to a dom component like div
    if ($9ba823149c88c072$export$dbaa4172856e20ab(child)) return (0, $iSvIT.cloneElement)(child, (0, $7Knp0._)({}, child.props, additionalProps));
    return child;
}
function $9ba823149c88c072$export$ce7eaaed37329a1b(children, callback) {
    return (0, $iSvIT.Children).map(children, (child, index)=>{
        // null happens when conditionally rendering TabPanel/Tab
        if (child === null) return null;
        if ($9ba823149c88c072$var$isTabChild(child)) return callback(child, index);
        if (child && child.props && child.props.children && typeof child.props.children === "object") // Clone the child that has children and map them too
        return (0, $iSvIT.cloneElement)(child, (0, $6iHNw._)((0, $7Knp0._)({}, child.props), {
            children: $9ba823149c88c072$export$ce7eaaed37329a1b(child.props.children, callback)
        }));
        return child;
    });
}
function $9ba823149c88c072$export$519ada94592b97fc(children, callback) {
    return (0, $iSvIT.Children).forEach(children, (child, index)=>{
        // null happens when conditionally rendering TabPanel/Tab
        if (child === null) return;
        if ($9ba823149c88c072$export$bdc9792d96913679(child) || $9ba823149c88c072$export$9e12445c79db89b(child)) callback(child, index);
        else if (child && child.props && child.props.children && typeof child.props.children === "object") {
            if ($9ba823149c88c072$export$9c326233b9ae5588(child)) callback(child, index);
            $9ba823149c88c072$export$519ada94592b97fc(child.props.children, callback);
        }
    });
}

});


parcelRegister("gq8af", function(module, exports) {

$parcel$export(module.exports, "DraggableTabList", function () { return $36f3fdc852638cc4$export$dbb4ac5a817c6612; });
/* draggable-tab-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
parcelRequire("62VZK");
var $cPhXv = parcelRequire("cPhXv");
const $36f3fdc852638cc4$export$dbb4ac5a817c6612 = ({ alignment: alignment = "start", tabSize: // @ts-ignore
tabSize = "large", children: children })=>{
    const containerRef = (0, $iSvIT.useRef)(null);
    const mouseDown = (0, $iSvIT.useRef)(false);
    const startX = (0, $iSvIT.useRef)(0);
    const scrollLeft = (0, $iSvIT.useRef)(0);
    const canDrag = (0, $iSvIT.useRef)(false);
    const { onKeyDown: onKeyDown } = (0, $cPhXv.useTabsContext)();
    const startDragging = (mouse, touch)=>{
        var _containerRef_current;
        if (!canDrag.current) return;
         // Start listening for mouseup and mousemove events outside of the tab list
        document.addEventListener("mouseup", stopDragging);
        document.addEventListener("mousemove", move);
        mouseDown.current = true;
        var _ref;
        startX.current = (_ref = touch && touch.touches[0] ? touch.touches[0].clientX : mouse === null || mouse === void 0 ? void 0 : mouse.clientX) !== null && _ref !== void 0 ? _ref : 0;
        var _containerRef_current_scrollLeft;
        scrollLeft.current = (_containerRef_current_scrollLeft = (_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.scrollLeft) !== null && _containerRef_current_scrollLeft !== void 0 ? _containerRef_current_scrollLeft : 0;
    };
    const stopDragging = ()=>{
        if (!canDrag.current) return;
         // Stop listening for mouseup and mousemove events
        document.removeEventListener("mouseup", stopDragging);
        document.removeEventListener("mousemove", move);
        mouseDown.current = false;
    };
    const move = (mouse, touch)=>{
        if (!canDrag.current || !mouseDown.current || !containerRef.current) return;
        let dragAmount = 0;
        if (touch && touch.changedTouches[0]) dragAmount = touch.changedTouches[0].clientX - startX.current;
        else if (mouse) dragAmount = mouse.clientX - startX.current;
        containerRef.current.scrollLeft = scrollLeft.current - dragAmount;
    };
    (0, $iSvIT.useEffect)(()=>{
        const updateCanDrag = ()=>{
            if (containerRef.current) {
                const container = containerRef.current;
                canDrag.current = container.scrollWidth > container.clientWidth;
            }
        };
        const setStartingPoint = ()=>{
            if (containerRef.current) {
                if (canDrag.current) {
                    const tabPanels = document.querySelector(".tab-panels");
                    const tabPanelsStyle = tabPanels && window.getComputedStyle(tabPanels);
                    containerRef.current.setAttribute("style", `padding-left: calc(${tabPanelsStyle === null || tabPanelsStyle === void 0 ? void 0 : tabPanelsStyle.marginLeft} + ${tabPanelsStyle === null || tabPanelsStyle === void 0 ? void 0 : tabPanelsStyle.paddingLeft});`);
                } else if (alignment === "start") containerRef.current.setAttribute("style", "margin-inline: 0px; padding-inline: 0px;");
            }
        };
        if (!containerRef.current) return;
        const observer = new ResizeObserver(()=>{
            updateCanDrag();
            setStartingPoint();
        });
        observer.observe(containerRef.current);
        return ()=>{
            observer.disconnect();
        };
    });
    const wrapperStyle = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        ref: containerRef,
        className: (0, $esG4f.default)([
            "_1reo15vq _p12f1osq _195g1wug _18zrzwfg _11q81vi7 _su071wqb _3hzp1wqb"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div" // @ts-ignore
        , {
            onTouchStart: (e)=>startDragging(undefined, e),
            onMouseDown: (e)=>startDragging(e),
            onTouchEnd: (e)=>{
                // @ts-ignore
                move(undefined, e);
                stopDragging();
            },
            onTouchMove: (e)=>move(undefined, e),
            onKeyDown: onKeyDown,
            className: (0, $esG4f.default)([
                "_1e0c1txw _4cvr1y6m _1bah1y6m _1n261q9c _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _qtt8glyw _1bsb1ns9 _p12f1osq _1moupxbi _zulp1ejb",
                "tab-list"
            ]),
            tabIndex: -1,
            role: "tablist",
            children: children
        })
    });
};
const $36f3fdc852638cc4$var$tabsContainerStyles = null;
$36f3fdc852638cc4$export$dbb4ac5a817c6612.tabsRole = "TabList";

});

parcelRegister("6YaIp", function(module, exports) {

$parcel$export(module.exports, "DraggableTab", function () { return $e90b6760ea28386b$export$3a29ca89d63c5c20; });
/* draggable-tab.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");
parcelRequire("62VZK");
var $cPhXv = parcelRequire("cPhXv");
// eslint-disable-next-line complexity
const $e90b6760ea28386b$export$3a29ca89d63c5c20 = (_param)=>{
    var { id: id, focus: focus, tabIndex: tabIndex, title: title, iconUrl: iconUrl, tabSize: tabSize = "large", bgColor: bgColor = "bgWhite", label: label, dataEventProps: dataEventProps, className: className, enableRovoBorder: enableRovoBorder = false, enableResponsiveTabSize: enableResponsiveTabSize = false } = _param, props = (0, $akGnX._)(_param, [
        "id",
        "focus",
        "tabIndex",
        "title",
        "iconUrl",
        "tabSize",
        "bgColor",
        "label",
        "dataEventProps",
        "className",
        "enableRovoBorder",
        "enableResponsiveTabSize"
    ]);
    const { goToTab: goToTab, isCurrentTab: isCurrentTab, userSelected: userSelected } = (0, $cPhXv.useTabsContext)();
    const startX = (0, $iSvIT.useRef)(0);
    const tabRef = /*#__PURE__*/ (0, $iSvIT.createRef)();
    const isTabSelected = isCurrentTab(tabIndex);
    (0, $iSvIT.useEffect)(()=>{
        if (!tabRef.current || !tabRef.current.parentElement || !tabRef.current.parentElement.scrollTo || !tabRef.current.parentElement.parentElement || !tabRef.current.parentElement.parentElement.scrollTo) return;
         // Scroll to the selected tab if it's not in view
        if (isTabSelected) {
            var _tabRef_current_parentElement;
            if ((_tabRef_current_parentElement = tabRef.current.parentElement) === null || _tabRef_current_parentElement === void 0 ? void 0 : _tabRef_current_parentElement.parentElement) {
                // calculate the offset to center the tab in the parent
                const offsetLeft = tabRef.current.offsetLeft - tabRef.current.parentElement.offsetLeft - tabRef.current.parentElement.offsetWidth / 2 + tabRef.current.offsetWidth / 2;
                tabRef.current.parentElement.parentElement.scrollTo({
                    left: offsetLeft,
                    top: 0,
                    behavior: "smooth"
                });
            }
            if (focus) tabRef.current.focus({
                preventScroll: true
            });
        }
        if (isTabSelected && dataEventProps && userSelected) tabRef.current.dispatchEvent(new Event("select"));
    }, [
        tabRef,
        isTabSelected,
        focus,
        userSelected,
        dataEventProps
    ]);
    const onMouseDown = (e)=>{
        var _props_onMouseDown;
        var _e_clientX;
        startX.current = (_e_clientX = e.clientX) !== null && _e_clientX !== void 0 ? _e_clientX : 0;
        (_props_onMouseDown = props.onMouseDown) === null || _props_onMouseDown === void 0 ? void 0 : _props_onMouseDown.call(props, e);
    };
    const onClick = (0, $iSvIT.useCallback)((e)=>{
        var _props_onClick;
        if (Math.abs(e.clientX - startX.current) > 15) // Prevent click event if user is dragging
        return;
        (_props_onClick = props.onClick) === null || _props_onClick === void 0 ? void 0 : _props_onClick.call(props, e);
        if (isTabSelected) return;
        goToTab(tabIndex);
    }, [
        isTabSelected,
        tabIndex,
        goToTab,
        props
    ]);
    const onKeyDown = (e)=>{
        if (e.code === "Space" || e.code === "Enter") {
            goToTab(tabIndex);
            e.preventDefault();
        }
    };
    const tabColor = bgColor === "bgWhite" ? (0, $5ohHq.wacToken)("color.neutral.light200") : (0, $5ohHq.wacToken)("color.neutral.light0");
    const tabStyles = null;
    const rovoBorderStyles = null;
    const borderStyles = null;
    const largeTabStyles = null;
    const smallTabStyles = null;
    const iconTabStyles = null;
    const iconLargeTabStyles = null;
    const iconSmallTabStyles = null;
    const responsiveIconTabStyles = null;
    const iconLargeContainerStyles = null;
    const iconSmallContainerStyles = null;
    const responsiveIconContainerStyles = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", (0, $6iHNw._)((0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, props), {
        ref: tabRef,
        className: className,
        id: `tab${id}`,
        "aria-selected": isTabSelected,
        "aria-controls": `panel${id}`,
        "aria-label": label,
        title: label,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onKeyDown: onKeyDown,
        role: "tab",
        tabIndex: -1
    }), dataEventProps), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("button", {
            className: (0, $esG4f.default)([
                "_o5721q9c _1ul9ymf6 _bfhk1jrh _4cvr1h6o _1bah1h6o _vchhusvi _1e0c1txw _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _2rko17td _19itq75r _80omtlke _4cvx17la _8y9r1hlo",
                iconUrl && "_2lx21bp4 _2rkoi2wt _1wyb1j6v",
                iconUrl && enableRovoBorder ? "_1h6d1j28 _1s79mzrp _1esp1ws1 _494pusvi _iusibx47" : "_1npj1ybm _1s7917la",
                iconUrl && enableResponsiveTabSize && "_4t3i1n2x _1ul9176v _1yt437zh _1xlocmky _1d2y11ux _6ytt139i",
                !iconUrl && tabSize === "large" && "_ca0qdlk8 _u5f31f4h _n3tddlk8 _19bv1f4h _vwz41f4h _4t3i1wqb _1wyb1cby",
                !iconUrl && tabSize === "small" && "_1yt41c98 _vwz4v47k _4t3i1ylp _1wyb1j6v",
                iconUrl && !enableResponsiveTabSize && tabSize === "large" && "_4t3icmky _1ul911ux _1yt4139i",
                iconUrl && !enableResponsiveTabSize && tabSize === "small" && "_4t3i1n2x _1ul9176v _1yt437zh",
                `${isTabSelected ? "currentTab" : ""}`
            ]),
            "data-product-key": "template",
            "data-event": "clicked",
            "data-event-component": "button",
            "data-event-container": "tabsMenu",
            "data-label": title,
            style: {
                "--_7aj7gm": (0, $43MIc.default)(tabColor),
                "--_514je1": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.pill")),
                "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                "--_1hkddbi": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue100"))
            },
            children: [
                iconUrl && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        !enableResponsiveTabSize && tabSize === "large" && "_4t3ickbl _1bsbckbl",
                        !enableResponsiveTabSize && tabSize === "small" && "_4t3i10mc _1bsb10mc",
                        enableResponsiveTabSize && "_4t3i10mc _1bsb10mc _1xlockbl _14b5ckbl",
                        "default-icon"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                        src: `${iconUrl || ""}`,
                        alt: "",
                        draggable: false
                    })
                }),
                title
            ]
        })
    }));
};
$e90b6760ea28386b$export$3a29ca89d63c5c20.tabsRole = "Tab";

});

parcelRegister("bN8aD", function(module, exports) {

$parcel$export(module.exports, "TabPanel", function () { return $9a33649b5acaee05$export$3d96ec278d3efce4; });
/* tab-panel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $8lB1y = parcelRequire("8lB1y");
parcelRequire("62VZK");
var $cPhXv = parcelRequire("cPhXv");
var $kWavG = parcelRequire("kWavG");
const $9a33649b5acaee05$var$hidePanelStyle = null;
const $9a33649b5acaee05$export$3d96ec278d3efce4 = (_param)=>{
    var { forceRender: forceRender, children: children, panelIndex: panelIndex, id: id, hideTabPanelRole: hideTabPanelRole } = _param, props = (0, $akGnX._)(_param, [
        "forceRender",
        "children",
        "panelIndex",
        "id",
        "hideTabPanelRole"
    ]);
    const { isCurrentTab: isCurrentTab } = (0, $cPhXv.useTabsContext)();
    const isTabSelected = isCurrentTab(panelIndex);
    const activeClass = isTabSelected ? "active-panel" : "";
    const { panelId: panelId, tabId: tabId } = (0, $8lB1y.generateSafeIds)(id, panelIndex);
    const originalChildrenCount = (0, $iSvIT.Children).count(children);
    const shouldHideRole = hideTabPanelRole !== undefined ? hideTabPanelRole : originalChildrenCount === 0;
    const { css: existingCss } = props, propsWithoutCss = (0, $akGnX._)(props, [
        "css"
    ]);
    const filteredProps = Object.fromEntries(Object.entries(propsWithoutCss).filter(([key])=>!key.startsWith("aria-") && key !== "role"));
    if (!shouldHideRole) return /*#__PURE__*/ (0, $loA2J.jsx)("div", (0, $6iHNw._)((0, $7Knp0._)({}, filteredProps), {
        id: panelId,
        "aria-labelledby": tabId,
        "aria-hidden": !isTabSelected,
        role: "tabpanel",
        className: (0, $esG4f.default)([
            !isTabSelected && !forceRender && "_1e0cglyw",
            [
                "tab-panel",
                activeClass
            ].join(" ")
        ]),
        children: (0, $iSvIT.Children).map(children, (child)=>{
            return (0, $kWavG.mapChild)(child, {
                isPanelActive: isTabSelected
            });
        })
    }));
    const cssProp = [
        !isTabSelected && !forceRender && $9a33649b5acaee05$var$hidePanelStyle
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        id: panelId,
        className: (0, $esG4f.default)([
            !isTabSelected && !forceRender && "_1e0cglyw",
            [
                "tab-panel",
                activeClass
            ].join(" ")
        ]),
        "aria-labelledby": undefined,
        "aria-hidden": undefined,
        role: undefined,
        children: (0, $iSvIT.Children).map(children, (child)=>{
            return (0, $kWavG.mapChild)(child, {
                isPanelActive: isTabSelected
            });
        })
    });
};
$9a33649b5acaee05$export$3d96ec278d3efce4.tabsRole = "TabPanel";

});

parcelRegister("7CBQh", function(module, exports) {

$parcel$export(module.exports, "TabsSection", function () { return $8c54ab3226897d8a$export$502de1d4d55224c1; });
/* tabs-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");
parcelRequire("62VZK");
var $cPhXv = parcelRequire("cPhXv");
var $gq8af = parcelRequire("gq8af");
var $6YaIp = parcelRequire("6YaIp");
var $bN8aD = parcelRequire("bN8aD");
const $8c54ab3226897d8a$export$502de1d4d55224c1 = ({ alignment: alignment = "start", tabsData: tabsData, tabSize: tabSize = "large", bgColor: bgColor = "bgWhite", enableRovoBorder: enableRovoBorder = false, enableResponsiveTabSize: enableResponsiveTabSize = false })=>{
    const sectionStyles = null;
    const fullWidthContainerStyles = null;
    const enableIconTabs = tabsData.every((tab)=>tab.iconUrl);
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        id: "tabs",
        className: (0, $esG4f.default)([
            "_1bsb1osq _1reo15vq _18m915vq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cPhXv.Tabs), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $gq8af.DraggableTabList), {
                    tabSize: tabSize,
                    alignment: alignment,
                    children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $6YaIp.DraggableTab), {
                            tabIndex: index,
                            title: tab.title,
                            iconUrl: enableIconTabs ? tab.iconUrl : undefined,
                            tabSize: tabSize,
                            bgColor: bgColor,
                            className: "round-tab",
                            enableRovoBorder: enableIconTabs && enableRovoBorder,
                            enableResponsiveTabSize: enableIconTabs && enableResponsiveTabSize
                        }, index))
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        tabSize === "large" && "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _1reoewfl _18m9ewfl _bozgzwfg _y4tizwfg _1bsb1osq _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _10jxzqdx",
                        "tab-panels"
                    ]),
                    children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $bN8aD.TabPanel), {
                            panelIndex: index,
                            id: tab.id || `tab-${index}`,
                            children: tab.tabComponent
                        }, index))
                })
            ]
        })
    });
};

});






//# sourceMappingURL=call-to-action.69eb65ed.js.map
